{
  "common": {
    "loading": "Caricamento...",
    "error": "Errore",
    "retry": "Riprova",
    "cancel": "Annulla",
    "save": "Salva",
    "saving": "Salvataggio...",
    "close": "Chiudi",
    "back": "Indietro",
    "next": "Avanti",
    "search": "Cerca",
    "watchNow": "Guarda ora",
    "playNow": "Riproduci ora",
    "play": "Riproduci",
    "moreInfo": "Altre info",
    "seeAll": "Vedi tutto",
    "new": "Nuovo",
    "live": "IN DIRETTA",
    "recommended": "Consigliato",
    "edit": "Modifica",
    "delete": "Elimina",
    "add": "Aggiungi",
    "enabled": "Attivato",
    "disabled": "Disattivato",
    "invalidDate": "Data non valida",
    "appName": "🏠 Bayit+",
    "appVersion": "🏠 Bayit+ v1.0.0",
    "slogan": "La Tua Casa. Ovunque.",
    "ok": "OK",
    "success": "Successo",
    "warning": "Avviso",
    "confirm": "Conferma",
    "yes": "Sì",
    "no": "No",
    "apply": "Applica",
    "errors": {
      "unexpected": "Si è verificato un errore imprevisto"
    },
    "send": "Invia",
    "done": "Fatto",
    "all": "Tutto",
    "reset": "Ripristina",
    "deleting": "Eliminazione...",
    "noResults": "Nessun risultato trovato",
    "tryDifferentSearch": "Prova un termine di ricerca diverso",
    "previous": "Precedente",
    "actions": "Azioni",
    "pageOf": "Pagina {{page}} di {{total}}",
    "noData": "Nessun dato disponibile",
    "filters": "Filtri",
    "clear": "Cancella",
    "clearSelection": "Cancella",
    "expand": "Espandi",
    "collapse": "Comprimi",
    "upgrade": "Passa a Premium",
    "skip": "Salta",
    "thisContent": "[it] this content",
    "backToHome": "[it] Back to Home",
    "dismiss": "[it] Dismiss",
    "goBack": "[it] Go Back",
    "pause": "[it] Pause",
    "tryAgain": "[it] Try Again",
    "refresh": "Aggiorna"
  },
  "culturalContext": {
    "loading": "Caricamento spiegazione...",
    "loadError": "Caricamento spiegazione non riuscito",
    "related": "Riferimenti correlati"
  },
  "demo": {
    "banner": "MODALITÀ DEMO",
    "bannerSubtext": "Utilizzo dati simulati - Nessuna chiamata API",
    "days": {
      "sunday": "Domenica",
      "monday": "Lunedì",
      "tuesday": "Martedì",
      "wednesday": "Mercoledì",
      "thursday": "Giovedì",
      "friday": "Venerdì",
      "saturday": "Sabato"
    },
    "shabbat": "Shabbat",
    "until_shabbat": "Fino a Shabbat",
    "search_interpretation": "Ricerca per \"{{query}}\"",
    "suggestions": {
      "0": "Fauda",
      "1": "Shtisel",
      "2": "Teheran",
      "3": "L'Arbitro",
      "4": "Lavoro"
    },
    "premium_plan": "Premium",
    "assistant_response": "Consiglio Fauda - un'eccellente serie thriller!",
    "morning_greeting": "Buongiorno! Oggi il tempo è bello, ci sono notizie importanti da Israele e ho selezionato contenuti speciali per te."
  },
  "hero": {
    "watch": "Guarda",
    "moreInfo": "Altre info",
    "addToList": "Aggiungi alla lista"
  },
  "login": {
    "title": "Bentornato",
    "subtitle": "Accedi per continuare su Bayit+",
    "tagline": "La Tua Casa negli USA",
    "email": "E-mail",
    "emailPlaceholder": "Inserisci la tua email",
    "password": "Password",
    "passwordPlaceholder": "Inserisci la tua password",
    "submit": "Accedi",
    "loggingIn": "Accesso in corso...",
    "or": "o",
    "forgotPassword": "Password dimenticata?",
    "continueWithGoogle": "Continua con Google",
    "noAccount": "Non hai un account?",
    "signUp": "Registrati",
    "register": "Registrati",
    "name": "Nome",
    "termsNotice": "Accedendo, accetti i nostri Termini di Servizio e l'Informativa sulla Privacy",
    "errors": {
      "emailRequired": "L'email è obbligatoria",
      "passwordRequired": "La password è obbligatoria",
      "loginFailed": "Accesso fallito. Verifica le tue credenziali.",
      "googleFailed": "Accesso con Google fallito. Riprova.",
      "fillAllFields": "Compila tutti i campi"
    },
    "qrInstructions": "Scansiona il codice con il telefono per un accesso rapido",
    "methodQR": "Codice QR",
    "methodVoice": "Voce",
    "methodTraditional": "E-mail",
    "qrTitle": "Scansiona per accedere",
    "qrDescription": "Scansiona questo codice QR con il telefono per accedere senza digitare",
    "expiresIn": "Scade tra 5 minuti",
    "companionConnected": "Telefono connesso!",
    "authenticating": "Accesso in corso...",
    "sessionExpired": "Sessione scaduta",
    "refreshQR": "Genera nuovo codice",
    "generatingQR": "Generazione codice QR...",
    "howItWorks": "Come funziona:",
    "step1": "Apri la fotocamera sul telefono",
    "step2": "Scansiona il codice QR sopra",
    "step3": "Accedi sul telefono",
    "step4": "La TV accede automaticamente!",
    "voicePlaceholder": "Digita la tua risposta...",
    "send": "Invia",
    "createAccount": "Crea account",
    "bayitThinking": "Bayit sta pensando...",
    "unexpectedError": "Si è verificato un errore imprevisto"
  },
  "tvLogin": {
    "invalidQR": "[it] Invalid QR code. Please scan again from your TV.",
    "sessionInvalid": "[it] This QR code has expired. Please generate a new one on your TV.",
    "verificationFailed": "[it] Failed to verify session. Please try again.",
    "fillAllFields": "[it] Please fill in all fields",
    "loginFailed": "[it] Login failed. Please check your credentials.",
    "notLoggedIn": "[it] You are not logged in on this device.",
    "enterCredentials": "[it] Please enter your credentials to authorize your TV.",
    "authFailed": "[it] Authorization failed.",
    "verifying": "[it] Verifying...",
    "verifyingDescription": "[it] Connecting to your TV...",
    "loginTitle": "[it] Login to Your TV",
    "loginDescription": "[it] Enter your credentials to authorize your TV",
    "authorizing": "[it] Authorizing...",
    "authorizingDescription": "[it] Logging you in on your TV...",
    "authorizeTV": "[it] Authorize TV",
    "success": "[it] Success!",
    "successDescription": "[it] Your TV is now logged in. You can close this page.",
    "goToHome": "[it] Go to Home",
    "error": "[it] Something went wrong",
    "tryAgain": "[it] Try Again",
    "securityNote": "[it] Your credentials are sent securely and are never stored on the TV.",
    "footer": "[it] Having trouble? Make sure you scanned a fresh QR code from your TV.",
    "almostThere": "[it] Almost there!",
    "authenticating": "[it] Authenticating...",
    "connected": "[it] Connected",
    "expired": "[it] Code Expired",
    "expiredMessage": "[it] Your sign-in code has expired. Please request a new one.",
    "header": "[it] Sign In to TV",
    "pleaseSignIn": "[it] Please sign in on your phone or computer",
    "signInButton": "[it] Sign In",
    "signInToTV": "[it] Sign In to TV",
    "subtitle": "[it] Enter the code shown on your TV screen",
    "tvSignedIn": "[it] TV signed in successfully"
  },
  "googleLogin": {
    "cancelledError": "[it] Google sign-in was cancelled",
    "missingCode": "[it] Authentication code is missing",
    "loginError": "[it] Error signing in with Google",
    "redirecting": "[it] Redirecting to login page...",
    "connecting": "[it] Connecting with Google..."
  },
  "register": {
    "title": "Crea account",
    "subtitle": "Unisciti a Bayit+ per guardare i tuoi contenuti preferiti",
    "name": "Nome completo",
    "namePlaceholder": "Mario Rossi",
    "email": "E-mail",
    "emailPlaceholder": "tua@email.com",
    "password": "Password",
    "passwordPlaceholder": "Almeno 8 caratteri",
    "confirmPassword": "Conferma password",
    "confirmPasswordPlaceholder": "Reinserisci la password",
    "submit": "Registrati",
    "registering": "Registrazione...",
    "acceptTerms": "Accetto i",
    "termsOfService": "Termini di Servizio",
    "and": "e",
    "privacyPolicy": "l'Informativa sulla Privacy",
    "continueWithGoogle": "Registrati con Google",
    "haveAccount": "Hai già un account?",
    "signIn": "Accedi",
    "fullName": "Nome completo",
    "loginLink": "Accedi",
    "placeholders": {
      "fullName": "[it] John Doe",
      "email": "[it] your@email.com",
      "password": "[it] At least 8 characters",
      "confirmPassword": "[it] Enter password again"
    },
    "errors": {
      "nameRequired": "Il nome è obbligatorio",
      "emailRequired": "L'email è obbligatoria",
      "passwordRequired": "La password è obbligatoria",
      "passwordTooShort": "La password deve essere di almeno 8 caratteri",
      "passwordMismatch": "Le password non corrispondono",
      "acceptTerms": "Devi accettare i Termini di Servizio e l'Informativa sulla Privacy",
      "fillAllFields": "Compila tutti i campi",
      "registrationFailed": "Registrazione fallita. Riprova.",
      "googleFailed": "Registrazione con Google fallita. Riprova."
    }
  },
  "nav": {
    "home": "Home",
    "vod": "VOD",
    "liveTV": "TV in diretta",
    "epg": "Guida TV",
    "radio": "Radio",
    "podcasts": "Podcast",
    "flows": "Flussi",
    "judaism": "Ebraismo",
    "children": "Bambini",
    "profile": "Profilo",
    "search": "Cerca",
    "settings": "Impostazioni",
    "favorites": "Preferiti",
    "watchlist": "Lista",
    "downloads": "Download",
    "recordings": "Registrazioni",
    "widgets": "Widget",
    "help": "Aiuto e supporto",
    "discover": "Scopri",
    "account": "Account",
    "subscribe": "Abbonati",
    "plans": "Piani",
    "admin": "Amministratore",
    "games": "Giochi",
    "friends": "Amici",
    "glossary": "Glossario",
    "missions": "Missioni",
    "audiobooks": "Audiolibri",
    "playlist": "Playlist",
    "zehAniHub": "Zeh Ani",
    "support": "Supporto",
    "discoverHub": "Scopri IA",
    "listen": "Ascolta",
    "byoc": "Le mie fonti",
    "household": "Famiglia",
    "messages": "Messaggi",
    "myContent": "I miei contenuti",
    "social": "Sociale"
  },
  "epg": {
    "title": "Guida TV",
    "subtitle": "Sfoglia la programmazione TV in diretta",
    "gridView": "Vista griglia",
    "listView": "Vista lista",
    "israelTime": "Ora di Israele",
    "localTime": "Ora locale",
    "il": "IL",
    "local": "Locale",
    "jumpToNow": "Vai a ora",
    "goBack": "← {{hours}}h",
    "goForward": "{{hours}}h →",
    "toggleTimezone": "Cambia fuso orario",
    "errorTitle": "Impossibile caricare la Guida TV",
    "errorLoading": "Impossibile caricare i dati della guida TV",
    "noPrograms": "Nessun programma trovato",
    "noChannels": "Nessun canale disponibile",
    "recordProgram": "Registra programma",
    "channel": "Canale",
    "enableSubtitles": "Abilita sottotitoli",
    "subtitleLanguage": "Lingua sottotitoli",
    "storageEstimate": "[it] Storage Estimate",
    "availableSpace": "[it] Available Space",
    "lowStorage": "[it] Low Storage Warning",
    "lowStorageMessage": "[it] You're running low on storage space. Consider deleting old recordings.",
    "scheduleRecording": "[it] Schedule Recording",
    "scheduledRecordingNotSupported": "[it] Scheduled recordings are not yet supported. Only immediate recordings are available.",
    "recordingFailed": "[it] Failed to start/schedule recording",
    "smartSearch": "Ricerca intelligente",
    "smartSearchSubtitle": "Fai domande in linguaggio naturale",
    "smartSearchPlaceholder": "[it] e.g., Show me all shows with actress Tali Sharon tonight",
    "searchPlaceholder": "Cerca programmi, canali, attori...",
    "premiumRequired": "Funzione Premium",
    "premiumRequiredMessage": "[it] Smart Search uses AI to understand your questions. Upgrade to Premium to access this feature.",
    "searchWithAI": "Cerca con AI",
    "searching": "Ricerca in corso...",
    "tryThese": "Prova questi esempi",
    "exampleQuery1": "[it] Show me all shows with actress Tali Sharon tonight",
    "exampleQuery2": "[it] What comedy shows are airing this week?",
    "exampleQuery3": "[it] Find documentaries about history on Channel 11",
    "exampleQuery4": "[it] Show me all news programs tomorrow morning",
    "aiDisclaimer": "Powered by Claude AI. I risultati possono variare.",
    "interpretationTitle": "Quello che ho capito",
    "noResultsFound": "Nessun programma trovato"
  },
  "home": {
    "continueWatching": "Continua a guardare",
    "featuredContent": "In evidenza",
    "liveTV": "TV in diretta",
    "allChannels": "Tutti i canali",
    "liveChannels": "Canali in diretta",
    "showOnlyWithSubtitles": "Mostra solo con sottotitoli",
    "israeliMovies": "Film israeliani",
    "israeli-movies": "Film israeliani",
    "israeli-series": "Serie israeliane",
    "action": "Azione e Thriller",
    "comedy": "Commedia",
    "drama": "Drammatico",
    "documentaries": "Documentari",
    "loadingContent": "Caricamento contenuti...",
    "liveNow": "In onda ora",
    "trendingInIsrael": "Di tendenza in Israele",
    "jerusalemConnection": "Connessione Gerusalemme",
    "telAvivConnection": "Connessione Tel Aviv",
    "categories": "Categorie",
    "nearYou": "Israeliani Vicino a Te",
    "betaExclusive": "Esclusivo Beta",
    "carousel": {
      "fauda": {
        "title": "[it] Fauda",
        "subtitle": "[it] Season 4 - Now Streaming",
        "description": "[it] The hit Israeli series returns for a fourth season full of suspense and action"
      },
      "shtisel": {
        "title": "[it] Shtisel",
        "subtitle": "[it] All Seasons Available",
        "description": "[it] Follow the Shtisel family in the ultra-Orthodox neighborhood of Jerusalem"
      },
      "tehran": {
        "title": "[it] Tehran",
        "subtitle": "[it] Season 2",
        "description": "[it] A Mossad agent deep in Iran on a dangerous mission"
      },
      "live": {
        "title": "[it] Live - Kan 11",
        "subtitle": "[it] Watch Now",
        "description": "[it] News, current affairs and quality content"
      }
    },
    "enableLocation": "[it] Enable Location",
    "locationPermissionDeniedDescription": "[it] Location access was denied. Enable it in Settings to see content near you.",
    "locationPermissionDescription": "[it] Allow location access to discover content near you.",
    "openSettings": "[it] Open Settings"
  },
  "search": {
    "title": "Cerca",
    "subtitle": "Trova film, serie, canali, radio e podcast",
    "placeholder": "Cerca contenuti...",
    "voicePlaceholder": "Parla ora...",
    "searching": "Ricerca in corso...",
    "listening": "In ascolto...",
    "noResults": "Nessun risultato trovato",
    "noResultsHint": "Prova parole chiave diverse o modifica i filtri",
    "tryDifferent": "Prova altri termini di ricerca",
    "resultsFor": "risultati per",
    "resultsFound": "{{count}} risultati trovati per \"{{query}}\"",
    "recentSearches": "Ricerche recenti",
    "clearAll": "Cancella tutto",
    "trending": "Ricerche di tendenza",
    "promptTitle": "Cosa stai cercando?",
    "promptDescription": "Cerca i tuoi contenuti preferiti o usa la ricerca vocale",
    "filters": {
      "all": "Tutto",
      "vod": "Film e Serie",
      "live": "Canali",
      "radio": "Radio",
      "podcast": "Podcast",
      "moviesAndSeries": "Film e Serie",
      "channels": "Canali",
      "podcasts": "Podcast"
    },
    "suggestions": {
      "movies": "Film",
      "series": "Serie",
      "liveTV": "TV in diretta",
      "news": "Notizie",
      "sports": "Sport",
      "kids": "Bambini"
    }
  },
  "liveTV": {
    "title": "TV in diretta",
    "channels": "Canali",
    "nowPlaying": "In onda",
    "loadError": "Impossibile caricare i canali",
    "categories": {
      "all": "Tutto",
      "news": "Notizie",
      "sports": "Sport",
      "entertainment": "Intrattenimento",
      "kids": "Bambini",
      "documentary": "Documentari"
    }
  },
  "listen": {
    "title": "Ascolta",
    "subtitle": "Radio, Podcast e Audiolibri",
    "tab": {
      "radio": "Radio",
      "podcasts": "Podcast",
      "audiobooks": "Audiolibri"
    }
  },
  "radio": {
    "title": "Radio",
    "categories": {
      "all": "Tutto",
      "music": "Musica",
      "news": "Notizie",
      "talk": "Parla",
      "jewish": "Ebraica"
    },
    "noStations": "Nessuna stazione radio disponibile",
    "tryLater": "Riprova più tardi",
    "playing": "IN RIPRODUZIONE",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "Podcast",
    "episodes": "episodi",
    "categories": {
      "all": "Tutto",
      "general": "Generale",
      "news": "Notizie",
      "politics": "Politica",
      "tech": "Tecnologia",
      "business": "Business",
      "jewish": "Ebraico",
      "entertainment": "Intrattenimento",
      "sports": "Sport",
      "history": "Storia",
      "educational": "Educativo"
    },
    "noPodcasts": "Nessun podcast disponibile",
    "tryLater": "Riprova più tardi",
    "playLatest": "[it] Play Latest"
  },
  "vod": {
    "title": "Film e Serie",
    "movies": "Film",
    "series": "Serie",
    "searchPlaceholder": "Cerca film e serie...",
    "noMovies": "Nessun film trovato",
    "noSeries": "Nessuna serie trovata",
    "loadError": "Impossibile caricare i contenuti",
    "showOnlyWithSubtitles": "Mostra solo con sottotitoli",
    "categories": {
      "all": "Tutto",
      "drama": "Drammatico",
      "comedy": "Commedia",
      "action": "Azione",
      "documentary": "Documentario",
      "kids": "Bambini"
    },
    "allCategories": "Tutto",
    "emptyTitle": "Nessun contenuto disponibile",
    "emptyDescription": "Prova a selezionare un'altra categoria",
    "allContent": "[it] All Content",
    "noContent": "[it] No content available",
    "noContentInCategory": "[it] No content found in this category"
  },
  "account": {
    "title": "Il mio account",
    "profile": "Profilo",
    "settings": "Impostazioni",
    "subscription": "Abbonamento",
    "manageSubscription": "Gestisci abbonamento",
    "personalDetails": "Dettagli personali",
    "billing": "Fatturazione e pagamento",
    "logout": "Esci",
    "login": "Accedi",
    "register": "Registrati",
    "email": "E-mail",
    "password": "Password",
    "name": "Nome",
    "guest": "Ospite",
    "premium": "Premium",
    "basic": "Base"
  },
  "flows": {
    "title": "[it] Flows",
    "subtitle": "[it] Personalized content experiences for every moment",
    "activeNow": "[it] Active Now",
    "start": "[it] Start",
    "skipToday": "[it] Skip Today",
    "systemFlows": "[it] Ready-Made Flows",
    "customFlows": "[it] My Flows",
    "system": "[it] System",
    "noCustomFlows": "[it] No custom flows yet",
    "createHint": "[it] Create your first personalized flow",
    "createCustom": "[it] Create Custom Flow",
    "createFlow": "[it] Create Flow",
    "editFlow": "[it] Edit Flow",
    "type": "[it] Type",
    "systemFlow": "[it] System Flow",
    "customFlow": "[it] Custom Flow",
    "schedule": "[it] Schedule",
    "content": "[it] Content",
    "items": "[it] items",
    "aiGenerated": "[it] AI Generated",
    "autoPlay": "[it] Auto Play",
    "aiEnabled": "[it] AI Curation",
    "shabbatTrigger": "[it] Shabbat Evening",
    "manual": "[it] Manual",
    "flowName": "[it] Flow Name",
    "flowNamePlaceholder": "[it] e.g., My Morning Routine",
    "description": "[it] Description",
    "descriptionPlaceholder": "[it] What is this flow for?",
    "startTime": "[it] Start Time",
    "endTime": "[it] End Time",
    "actions": "[it] Actions",
    "details": "[it] Details",
    "createFlowDesc": "[it] Design your personalized content experience",
    "editFlowDesc": "[it] Update your flow settings and content",
    "basicInfo": "[it] Basic Information",
    "options": "[it] Options",
    "autoPlayDesc": "[it] Automatically play next item when current one ends",
    "aiEnabledDesc": "[it] Let AI curate content based on your preferences",
    "startFlow": "[it] Start Flow",
    "deleteFlow": "[it] Delete Flow",
    "custom": "[it] Custom",
    "morning": "[it] Morning",
    "evening": "[it] Evening",
    "shabbat": "[it] Shabbat",
    "addContent": "[it] Add Content",
    "contentPicker": {
      "title": "[it] Add Content to Flow",
      "tabs": {
        "live": "[it] Live TV",
        "radio": "[it] Radio",
        "vod": "[it] On Demand",
        "podcast": "[it] Podcasts"
      },
      "search": "[it] Search content...",
      "selected": "[it] {{count}} selected",
      "addSelected": "[it] Add Selected",
      "noResults": "[it] No content found",
      "alreadyAdded": "[it] Already in flow",
      "loadMore": "[it] Load More"
    },
    "flowItems": {
      "title": "[it] Flow Content",
      "empty": "[it] No content yet. Click Add Content to get started.",
      "count": "[it] {{count}} items",
      "remove": "[it] Remove",
      "moveUp": "[it] Move Up",
      "moveDown": "[it] Move Down",
      "order": "[it] Order",
      "confirmRemove": "[it] Click again to confirm removal",
      "maxReached": "[it] Maximum {{max}} items reached",
      "more": "[it] more items"
    },
    "days": {
      "sunday": "[it] Sunday",
      "monday": "[it] Monday",
      "tuesday": "[it] Tuesday",
      "wednesday": "[it] Wednesday",
      "thursday": "[it] Thursday",
      "friday": "[it] Friday",
      "saturday": "[it] Saturday",
      "sundayShort": "[it] Sun",
      "mondayShort": "[it] Mon",
      "tuesdayShort": "[it] Tue",
      "wednesdayShort": "[it] Wed",
      "thursdayShort": "[it] Thu",
      "fridayShort": "[it] Fri",
      "saturdayShort": "[it] Sat",
      "selectAll": "[it] Select All",
      "deselectAll": "[it] Deselect All",
      "title": "[it] Active Days",
      "everyday": "[it] Every day",
      "everyDay": "[it] Every day",
      "weekdays": "[it] Weekdays",
      "weekends": "[it] Weekends",
      "noneSelected": "[it] No days selected",
      "selectedCount": "[it] {{count}} days selected"
    },
    "trigger": {
      "type": "[it] Trigger Type",
      "time": "[it] Time-based",
      "shabbat": "[it] Shabbat Evening",
      "holiday": "[it] Holiday",
      "skipShabbat": "[it] Skip on Shabbat",
      "skipShabbatDesc": "[it] Don't run this flow on Friday evening or Saturday",
      "shabbatOffset": "[it] Minutes before candle lighting",
      "shabbatOffsetDesc": "[it] How many minutes before Shabbat should this flow start?",
      "calculatedTime": "[it] Calculated time",
      "thisWeek": "[it] This week: {{day}} at {{time}}",
      "comingSoon": "[it] Holiday triggers coming soon",
      "locationBased": "[it] Times based on your location"
    },
    "examples": {
      "title": "[it] Example Flows",
      "subtitle": "[it] Tap to use as a template",
      "morningRoutine": {
        "name": "[it] Morning Routine",
        "desc": "[it] Start your day with news, weather, and uplifting content"
      },
      "eveningWindDown": {
        "name": "[it] Evening Wind Down",
        "desc": "[it] Relax with calming music and light entertainment"
      },
      "shabbatPrep": {
        "name": "[it] Shabbat Preparation",
        "desc": "[it] Set the mood for Shabbat with special content"
      },
      "coffeeBreak": {
        "name": "[it] Coffee Break",
        "desc": "[it] Quick entertainment for a short break"
      },
      "sunsetVibes": {
        "name": "[it] Sunset Vibes",
        "desc": "[it] Weekend relaxation with music and ambient content"
      }
    },
    "aiBrief": "[it] AI Brief",
    "aiBriefDesc": "[it] Get a personalized AI-generated summary before the flow starts",
    "aiBriefEnabled": "[it] AI Brief Enabled",
    "validation": {
      "nameRequired": "[it] Flow name is required",
      "startTimeRequired": "[it] Start time is required",
      "endTimeRequired": "[it] End time is required",
      "timeRange": "[it] End time must be after start time",
      "daysRequired": "[it] Select at least one day",
      "contentRequired": "[it] Add content or enable AI"
    },
    "tv": {
      "useCompanion": "[it] For full customization, use the Bayit+ app on your phone or visit bayit.plus on your computer."
    }
  },
  "profile": {
    "title": "[it] My Profile",
    "profileDetails": "[it] Profile Details",
    "name": "[it] Name",
    "notSet": "[it] Not set",
    "email": "[it] Email",
    "editProfile": "[it] Edit Profile",
    "notificationSettings": "[it] Notification Settings",
    "security": "[it] Security",
    "changePassword": "[it] Change Password",
    "updatePassword": "[it] Update your password",
    "connectedDevices": "[it] Connected Devices",
    "manageDevices": "[it] Manage devices connected to your account",
    "twoFactorAuth": "[it] Two-Factor Authentication",
    "addExtraSecurity": "[it] Add an extra layer of security",
    "address": {
      "line1": "[it] 123 Main Street",
      "line2": "[it] Tel Aviv, Israel 6100000"
    },
    "free": "[it] Free",
    "premiumPrice": "[it] $7.99/month",
    "familyPrice": "[it] $12.99/month",
    "remaining": "[it] remaining",
    "tabs": {
      "personal": "[it] Personal",
      "overview": "[it] Overview",
      "subscription": "[it] Subscription",
      "notifications": "[it] Notifications",
      "security": "[it] Security",
      "ai": "[it] AI & Voice",
      "voice": "[it] Voice & Accessibility"
    },
    "subscription": {
      "currentPlan": "[it] Current Plan",
      "renewsOn": "[it] Renews on",
      "manageSubscription": "[it] Manage Subscription",
      "cancelSubscription": "[it] Cancel Subscription",
      "noActivePlan": "[it] No active subscription",
      "selectPlan": "[it] Select a Plan"
    },
    "notifications": "[it] Notifications",
    "ai": {
      "title": "[it] AI & Personalization",
      "description": "[it] Configure AI-powered features",
      "assistant": "[it] AI Assistant",
      "assistantDesc": "[it] Personalized recommendations and help",
      "chatbot": "[it] AI Assistant",
      "chatbotEnabled": "[it] Enable AI Assistant",
      "chatbotEnabledDesc": "[it] Get help navigating content",
      "saveHistory": "[it] Save Conversation History",
      "saveHistoryDesc": "[it] Remember previous conversations",
      "recommendations": "[it] Recommendations",
      "personalizedRecs": "[it] Personalized Recommendations",
      "personalizedRecsDesc": "[it] Content suggestions based on history",
      "privacy": "[it] Privacy & Data",
      "privacyDesc": "[it] Your data is encrypted and secure",
      "dataConsent": "[it] Usage Analytics",
      "dataConsentDesc": "[it] Help improve AI features",
      "privacyNote": "[it] Your data is encrypted and secure"
    },
    "voice": {
      "title": "[it] Voice Control",
      "description": "[it] Hands-free navigation",
      "enabled": "[it] Voice Commands",
      "enabledDesc": "[it] Control the app with your voice",
      "tts": "[it] Text-to-Speech",
      "ttsDesc": "[it] AI responses read aloud",
      "wakeWord": "[it] Wake Word Detection",
      "wakeWordDesc": "[it] Say \"Bayit\" to activate",
      "operationMode": "[it] Operation Mode",
      "operationModeDesc": "[it] Choose how you interact with the app",
      "voiceSearch": "[it] Voice Search",
      "voiceSearchEnabled": "[it] Enable voice search",
      "voiceSearchEnabledDesc": "[it] Search for content using your voice",
      "constantListening": "[it] Always Listening Mode",
      "constantListeningDesc": "[it] Continuously listen for voice commands without pressing a button",
      "constantListeningPrivacy": "[it] Audio is only sent to servers when speech is detected",
      "holdButtonMode": "[it] Hold Button to Talk",
      "holdButtonModeDesc": "[it] Press and hold the microphone button instead of always listening",
      "sensitivity": "[it] Voice Detection Sensitivity",
      "sensitivityDesc": "[it] Adjust how responsive the voice detection is",
      "sensitivityLow": "[it] Low (fewer false triggers)",
      "sensitivityMedium": "[it] Medium (balanced)",
      "sensitivityHigh": "[it] High (most responsive)",
      "silenceThreshold": "[it] Silence Detection",
      "silenceThresholdDesc": "[it] How long to wait after speaking before processing",
      "language": "[it] Voice language",
      "accessibility": "[it] Accessibility",
      "autoSubtitle": "[it] Auto-enable subtitles",
      "autoSubtitleDesc": "[it] Automatically show subtitles when playing content",
      "highContrast": "[it] High contrast mode",
      "highContrastDesc": "[it] Increase contrast for better visibility",
      "textSize": "[it] Text size",
      "textSizeSmall": "[it] Small",
      "textSizeMedium": "[it] Medium",
      "textSizeLarge": "[it] Large",
      "voiceOnlyInfo": "[it] Voice Only Mode",
      "voiceOnlyDetails": "[it] Say \"Hi Bayit\" to activate. Remote control disabled. Navigate entirely with voice commands.",
      "hybridInfo": "[it] Hybrid Mode",
      "hybridDetails": "[it] Use voice or remote control. Voice feedback on non-voice actions.",
      "classicInfo": "[it] Classic Mode",
      "classicDetails": "[it] All voice features disabled. Remote control only.",
      "textToSpeech": "[it] Voice Responses",
      "ttsEnabled": "[it] Enable voice responses",
      "ttsEnabledDesc": "[it] App will speak responses to your voice commands",
      "ttsVolume": "[it] Voice Volume",
      "ttsSpeed": "[it] Speaking Speed",
      "hybridFeedback": "[it] Interactive Feedback",
      "voiceFeedback": "[it] Voice feedback on actions",
      "voiceFeedbackDesc": "[it] Get voice confirmation when you use the remote or click buttons",
      "feedbackExample": "[it] Example: Click a movie → App says \"Playing [Movie Name]\""
    },
    "dropdown": {
      "myProfile": "[it] My Profile",
      "subscription": "[it] Subscription",
      "favorites": "[it] Favorites",
      "downloads": "[it] Downloads",
      "signOut": "[it] Sign Out"
    },
    "guest": "[it] Guest",
    "morningRitual": "[it] Morning Ritual",
    "watchlist": "[it] Watchlist",
    "favorites": "[it] Favorites",
    "downloads": "[it] Downloads",
    "settings": "[it] Settings",
    "language": "[it] Language",
    "admin": "[it] Admin",
    "watchTime": "[it] Watch Time",
    "minutes": "[it] minutes",
    "hours": "[it] hours",
    "logout": "[it] Log Out",
    "premium": "[it] Premium",
    "basic": "[it] Basic",
    "upgrade": "[it] Upgrade to Premium",
    "memberSince": "[it] Member since",
    "aiAssistant": "[it] AI Assistant",
    "voiceSettings": "[it] Voice",
    "subscriptionButton": "[it] Subscription",
    "recentActivity": "[it] Recent Activity",
    "justNow": "[it] Just now",
    "hoursAgo": "[it] {{hours}} hours ago",
    "yesterday": "[it] Yesterday",
    "noRecentActivity": "[it] No recent activity",
    "accountInfo": "[it] Account Information",
    "role": "[it] Role",
    "accountSecurity": "[it] Account Security",
    "securityNote": "[it] Your account is secured with encrypted authentication",
    "lastLogin": "[it] Last login",
    "dangerZone": "[it] Danger Zone",
    "invalidImageType": "[it] Please select a valid image file (JPEG, PNG, WebP, or GIF)",
    "imageTooLarge": "[it] Image is too large. Maximum size is 5MB.",
    "uploadSuccess": "[it] Avatar updated successfully!",
    "uploadFailed": "[it] Failed to upload avatar. Please try again.",
    "complimentaryPremium": "ACCESSO PREMIUM GRATUITO",
    "emailVerified": "Email verificata",
    "emailUnverified": "Email non verificata",
    "phoneVerified": "Telefono verificato",
    "phoneUnverified": "Telefono non verificato",
    "completeVerification": "Completa la verifica per sbloccare tutte le funzionalità",
    "unlockPremium": "Sblocca Funzionalità Premium",
    "unlockPremiumDescription": "Effettua l'upgrade per goderti contenuti e funzionalità esclusive"
  },
  "voiceMode": {
    "voiceOnly": "[it] Voice Only",
    "voiceOnlyDesc": "[it] No remote control - full voice navigation",
    "hybrid": "[it] Hybrid",
    "hybridDesc": "[it] Voice + Remote - voice feedback on actions",
    "classic": "[it] Classic",
    "classicDesc": "[it] No voice - remote control only"
  },
  "settings": {
    "title": "Impostazioni",
    "language": "Lingua",
    "appLanguage": "Lingua dell'app",
    "selectLanguage": "Seleziona lingua",
    "languages": {
      "en": "Inglese",
      "he": "Ebraico",
      "es": "Spagnolo",
      "zh": "中文",
      "fr": "Francese",
      "it": "Italiano",
      "hi": "Hindi",
      "ta": "Tamil",
      "bn": "Bengalese",
      "ja": "日本語"
    },
    "chatTranslation": "Traduzione chat",
    "autoTranslate": "Traduci automaticamente i messaggi",
    "autoTranslateDescription": "Traduci automaticamente i messaggi nella tua lingua preferita",
    "notifications": "Notifiche",
    "pushNotifications": "Notifiche push",
    "playback": "Riproduzione",
    "quality": "Qualità",
    "subtitles": "Sottotitoli",
    "autoplay": "Riproduzione automatica",
    "appearance": "Aspetto",
    "darkMode": "Modalità scura",
    "privacy": "Privacy",
    "privacyPolicy": "Informativa sulla Privacy",
    "termsOfService": "Termini di Servizio",
    "about": "Informazioni",
    "display": "[it] Display",
    "homePageSections": "[it] Home Page Sections",
    "configureSections": "[it] Configure which sections appear on your home page",
    "visibleSections": "[it] Visible Sections",
    "hiddenSections": "[it] Hidden Sections",
    "dragToReorder": "[it] Drag to reorder",
    "tapToHide": "[it] Tap to hide",
    "tapToShow": "[it] Tap to show",
    "resetToDefault": "[it] Reset to Default",
    "resetConfirmMessage": "[it] Are you sure you want to reset home page sections to their default configuration?",
    "sectionHidden": "[it] Section hidden",
    "sectionShown": "[it] Section shown",
    "replayTour": "Rivedi il tour delle funzionalità"
  },
  "help": {
    "subtitle": "[it] How can we help you?",
    "email": "[it] Email Support",
    "phone": "[it] Phone Support",
    "chat": "[it] Live Chat",
    "chatAvailable": "[it] Available 24/7",
    "openTooltip": "[it] Open help tooltip",
    "openHelp": "[it] Open help menu",
    "howTo": "[it] How to use",
    "relatedArticles": "[it] Related articles",
    "stillNeedHelp": "[it] Still need help?",
    "contactSupport": "[it] Contact Support",
    "previous": "[it] Previous",
    "next": "[it] Next",
    "getStarted": "[it] Get Started",
    "skipTutorial": "[it] Skip tutorial",
    "actions": {
      "search": "[it] Search Help",
      "docs": "[it] Documentation",
      "faq": "[it] FAQ",
      "support": "[it] Contact Support",
      "tutorial": "[it] View Tutorial"
    },
    "search": {
      "placeholder": "[it] Search help...",
      "noResults": "[it] No results found for \"{{query}}\"",
      "noResultsHint": "[it] Try different keywords or browse categories",
      "recent": "[it] Recent",
      "popular": "[it] Popular"
    },
    "categories": {
      "getting-started": "[it] Getting Started",
      "features": "[it] Features",
      "judaism": "[it] Judaism",
      "platform-guides": "[it] Platform Guides",
      "account": "[it] Account",
      "troubleshooting": "[it] Troubleshooting",
      "parents": "[it] For Parents",
      "admin": "[it] Admin Guide",
      "developer": "[it] Developer API"
    },
    "faq": {
      "title": "[it] Frequently Asked Questions",
      "q1": "[it] How do I change my subscription plan?",
      "a1": "[it] Go to Settings > Subscription to view and change your current plan. You can upgrade or downgrade at any time.",
      "q2": "[it] How do I download content for offline viewing?",
      "a2": "[it] Tap the download icon on any content to save it for offline viewing. Downloads are available on mobile devices only.",
      "q3": "[it] Why isn't my video playing?",
      "a3": "[it] Check your internet connection. If the problem persists, try clearing the app cache or restarting the app.",
      "q4": "[it] How do I cancel my subscription?",
      "a4": "[it] You can cancel your subscription anytime through Settings > Subscription > Cancel Plan. You'll continue to have access until the end of your billing period."
    },
    "onboarding": {
      "welcome": {
        "title": "[it] Welcome to Bayit+",
        "description": "[it] Your home for Israeli entertainment, anywhere in the world"
      },
      "liveTv": {
        "title": "[it] Live TV",
        "description": "[it] Watch Israeli channels live, including news, sports, and entertainment"
      },
      "vod": {
        "title": "[it] On-Demand Content",
        "description": "[it] Browse movies, series, and documentaries anytime"
      },
      "voice": {
        "title": "[it] Voice Control",
        "description": "[it] Say 'Bayit' to control the app with your voice"
      },
      "profiles": {
        "title": "[it] Family Profiles",
        "description": "[it] Create profiles for each family member with personalized recommendations"
      }
    }
  },
  "voice": {
    "panelTitle": "Assistente vocale",
    "typeCommand": "Digita un comando...",
    "controlExecuted": "Eseguito: {{action}}",
    "timerSet": "Timer impostato per {{amount}} {{unit}}",
    "chatPending": "Elaborazione del tuo messaggio...",
    "suggestion": {
      "watchLive": "Guarda la TV in diretta",
      "search": "Cerca contenuto",
      "listenRadio": "Ascolta la radio"
    },
    "error": {
      "micDenied": "Accesso al microfono negato",
      "notSupported": "I comandi vocali non sono supportati in questo browser",
      "recognitionFailed": "Non è stato possibile capire. Riprova."
    }
  },
  "errors": {
    "networkError": "Errore di rete",
    "loadingFailed": "Caricamento fallito",
    "tryAgain": "Riprova",
    "offline": {
      "title": "Nessuna connessione Internet",
      "message": "Sei attualmente offline. Alcune funzioni potrebbero non essere disponibili.",
      "ttsMessage": "Nessuna connessione Internet. Sei ora in modalità offline."
    },
    "online": {
      "title": "Connessione ripristinata",
      "message": "Sei di nuovo online.",
      "ttsMessage": "Connessione Internet ripristinata."
    },
    "api": {
      "badRequest": "Qualcosa è andato storto. Riprova.",
      "unauthorized": "Accedi per continuare.",
      "forbidden": "Non hai il permesso di accedere a questo contenuto.",
      "notFound": "Il contenuto che cerchi non è disponibile.",
      "rateLimit": "Troppe richieste. Attendi un momento.",
      "serverError": "I nostri server hanno problemi. Riprova più tardi.",
      "unknown": "Qualcosa è andato storto. Riprova.",
      "networkTimeout": "[it] Unable to connect to our servers. Please check your connection.",
      "offlineMessage": "[it] You are offline. Please check your internet connection.",
      "requestFailed": "[it] Something went wrong. Please try again."
    },
    "voice": {
      "permissionDenied": "L'accesso al microfono è richiesto per i comandi vocali. Abilitalo nelle Impostazioni.",
      "recognitionFailed": "Non ho capito. Riprova.",
      "commandFailed": "Comando vocale fallito. Riprova."
    },
    "widget": {
      "loadFailed": "[it] Unable to load widget. Please try again."
    },
    "buttons": {
      "ok": "OK",
      "retry": "Riprova",
      "cancel": "Annulla"
    },
    "title": "Errore",
    "networkUnavailable": "Rete non disponibile",
    "no_audio_url": "URL audio non disponibile",
    "connection_failed": "Connessione Fallita",
    "quota_exceeded": "Quota Superata",
    "server_error": "Errore del Server"
  },
  "player": {
    "loading": "Caricamento...",
    "retry": "Riprova",
    "error": "Errore riproduzione video",
    "back": "← Indietro",
    "liveBadge": "IN DIRETTA",
    "noStream": "Stream non disponibile",
    "loadError": "Impossibile caricare lo stream",
    "settings": "Impostazioni",
    "subtitles": "[it] Subtitles",
    "playbackSpeed": "Velocità di riproduzione",
    "quality": "Qualità",
    "auto": "Automatico",
    "previousChapter": "Capitolo precedente",
    "nextChapter": "Capitolo successivo",
    "skipBackward": "Indietro di 30 secondi",
    "skipForward": "Avanti di 30 secondi",
    "restart": "Riavvia dall'inizio",
    "subtitlesOff": "Disattivati",
    "speed": "Velocità",
    "subscription": {
      "requiredTitle": "Abbonamento richiesto",
      "requiredMessage": "richiede un abbonamento a pagamento",
      "upgradeInfo": "Aggiorna il tuo abbonamento per accedere ai contenuti premium",
      "upgrade": "Aggiorna ora"
    },
    "ai": {
      "dub": "Dub",
      "dubbing": "Doppiaggio",
      "featuresTitle": "Funzionalità IA",
      "languagePrimary": "Principale",
      "languageSecondary": "Secondario (facoltativo)",
      "languageTitle": "Lingua IA",
      "liveTranslate": "Traduzione in diretta",
      "selectLanguage": "Seleziona lingua",
      "split": "Dividi",
      "togglePanel": "Attiva/Disattiva pannello IA",
      "translate": "Traduci",
      "trivia": "Curiosità",
      "triviaToggle": "[it] Trivia"
    },
    "catchup": {
      "description": "Hai perso l'inizio? Ottieni un riassunto generato dall'IA di quello che è successo finora.",
      "generateSummary": "Genera riassunto",
      "summaryTitle": "Riepilogo",
      "title": "Recupera",
      "keyPoints": "[it] Key Points",
      "transcript": "[it] Transcript"
    },
    "chat": {
      "title": "Chat dal vivo",
      "messagePlaceholder": "Scrivi un messaggio..."
    },
    "companion": {
      "noContext": "Nessun contesto culturale disponibile per questo contenuto al momento.",
      "quizComplete": "Quiz completato",
      "quizRetry": "Riprova",
      "quizStart": "Inizia il quiz",
      "quizTitle": "Pronto a testare le tue conoscenze?",
      "quizTryAgain": "Riprova",
      "tabContext": "Contesto",
      "tabQuiz": "Quiz",
      "tabVocabulary": "Vocabolario",
      "tapWords": "Tocca le parole nei sottotitoli per aggiungerle qui",
      "title": "Compagno IA",
      "loadError": "Caricamento dati di apprendimento non riuscito"
    },
    "controls": {
      "audioTrack": "Traccia audio",
      "continueWatching": "Continua a guardare",
      "dismiss": "Chiudi",
      "goBack": "Indietro",
      "navigateBack": "Torna indietro",
      "on": "ON",
      "pause": "Pausa",
      "play": "Riproduci",
      "preview": "Anteprima",
      "selected": "Selezionato",
      "send": "Invia",
      "skip": "Salta",
      "close": "[it] Close",
      "exitFullscreen": "[it] Exit Fullscreen",
      "fullscreen": "[it] Fullscreen",
      "restart": "[it] Restart",
      "skipBackward": "[it] Skip Backward",
      "skipForward": "[it] Skip Forward",
      "volume": "[it] Volume"
    },
    "dubbing": {
      "notNow": "Non ora",
      "premiumMessage": "Il doppiaggio in diretta richiede un abbonamento Premium o Beta 500",
      "premiumTitle": "Funzionalità Premium",
      "upgrade": "Aggiorna",
      "voiceTitle": "Voce di doppiaggio",
      "settings_title": "Impostazioni Doppiaggio in Diretta",
      "target_language": "Lingua di Destinazione"
    },
    "errors": {
      "streamLimitMessage": "Hai raggiunto il massimo di {{maxStreams}} streaming simultanei. Interrompi un altro streaming o aggiorna il tuo piano.",
      "streamLimitTitle": "Limite di streaming raggiunto",
      "upgradePlan": "Aggiorna piano"
    },
    "audio_description": "Descrizione Audio",
    "dismiss": "Chiudi",
    "scene_search": "Ricerca Scena",
    "search_placeholder": "Cerca una scena...",
    "language_ratio": "Rapporto di Apprendimento Linguistico",
    "go_back": "Indietro",
    "sleepTimer": {
      "title": "Timer di spegnimento",
      "subtitle": "Metti in pausa automaticamente la riproduzione dopo un tempo impostato",
      "minutes": "{{count}} min",
      "customPlaceholder": "Minuti personalizzati",
      "set": "Imposta timer",
      "remaining": "Spegnimento tra {{time}}",
      "extend": "+15 min",
      "cancel": "Annulla timer",
      "off": "[it] Off",
      "setTimer": "[it] Set Sleep Timer"
    },
    "openSubs": {
      "title": "Cerca sottotitoli",
      "searchPlaceholder": "Cerca per titolo...",
      "search": "Cerca",
      "searchFailed": "Ricerca fallita. Riprova.",
      "downloads": "{{count}} download",
      "noResults": "Nessun sottotitolo trovato"
    },
    "dialogue": {
      "cancel": "[it] Cancel",
      "close": "[it] Close",
      "placeholder": "[it] Type your message...",
      "selectCharacter": "[it] Select Character",
      "send": "[it] Send",
      "sharedSession": "[it] Shared Session",
      "waitingForTurn": "[it] Waiting for your turn...",
      "yourAvatar": "[it] Your Avatar"
    },
    "interaction": {
      "next": "[it] Next",
      "previous": "[it] Previous",
      "skip": "Salta",
      "start": "Inizia interazione",
      "window": "Finestra di interazione: {{duration}} secondi"
    },
    "pauseAsk": {
      "askAgain": "[it] Ask Again",
      "placeholder": "[it] Ask about this scene...",
      "resume": "[it] Resume",
      "resumeMovie": "[it] Resume Movie",
      "selectCharacter": "[it] Select Character",
      "title": "[it] Pause & Ask"
    },
    "phraseBreakdown": {
      "literal": "Letterale",
      "meaning": "Significato",
      "origin": "Origine",
      "funFact": "Curiosità",
      "usage": "Uso: {{level}}"
    },
    "translation": {
      "example": "Esempio:",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "Modalità sottotitoli",
      "modes": {
        "regular": {
          "name": "Normale",
          "description": "Sottotitoli ebraici standard senza segni vocalici"
        },
        "nikud": {
          "name": "Nikud",
          "description": "Ebraico con segni vocalici per una lettura più facile"
        },
        "shoresh": {
          "name": "Shoresh",
          "description": "Apprendimento basato sulle radici con origini delle parole evidenziate"
        },
        "engrew": {
          "name": "Engrew",
          "description": "Traslitterazione inglese con contesto ebraico"
        },
        "heblish": {
          "name": "Heblish",
          "description": "Inglese con termini ebraici e contesto culturale"
        },
        "grammarFlip": {
          "name": "Inversione grammaticale",
          "description": "Struttura della frase ebraica con parole inglesi"
        },
        "slangSynthesis": {
          "name": "Sintesi gergale",
          "description": "Slang culturale ed espressioni idiomatiche spiegate"
        }
      }
    }
  },
  "empty": {
    "noContent": "[it] No content available",
    "tryAnotherCategory": "[it] Try selecting another category",
    "noPodcasts": "[it] No podcasts available",
    "tryLater": "[it] Try again later",
    "noResults": "[it] No results found"
  },
  "content": {
    "play": "Riproduci",
    "addToList": "Aggiungi alla lista",
    "inList": "Nella lista",
    "details": "Dettagli",
    "synopsis": "Sinossi",
    "genre": "Genere",
    "genres": "Generi",
    "runtime": "Durata",
    "released": "Uscita",
    "director": "Regista",
    "starring": "Con",
    "cast": "Trasmetti",
    "season": "Stagione",
    "seasons": "Stagioni",
    "episode": "Episodio",
    "episodes": "Episodi",
    "ep": "Ep",
    "selectSeason": "Seleziona stagione",
    "noEpisodes": "Nessun episodio disponibile",
    "noEpisodesAvailable": "Nessun episodio disponibile da riprodurre",
    "loadingSeries": "Caricamento informazioni serie...",
    "votes": "voti",
    "rating": "Voto",
    "imdbRating": "Voto IMDB",
    "preview": "Anteprima",
    "previewPlaying": "Anteprima in riproduzione",
    "trailerPlaying": "Trailer in riproduzione",
    "watchTrailer": "Guarda trailer",
    "youMayAlsoLike": "Potrebbe piacerti anche",
    "relatedContent": "Contenuti correlati",
    "notFound": "Contenuto non trovato",
    "availableSubtitles": "Sottotitoli disponibili",
    "subtitleSelected": "Selezionato: {{language}}"
  },
  "breadcrumbs": {
    "series": "[it] Series",
    "movie": "[it] Movie",
    "watching": "[it] Watching",
    "channel": "[it] Channel",
    "station": "[it] Station",
    "podcast": "[it] Podcast",
    "watchlist": "[it] Watchlist",
    "downloads": "[it] Downloads"
  },
  "favorites": {
    "title": "Preferiti",
    "items": "elementi",
    "empty": "Nessun preferito ancora",
    "emptyHint": "Aggiungi elementi ai tuoi preferiti"
  },
  "downloads": {
    "title": "Download",
    "items": "elementi",
    "storage": "Spazio",
    "empty": "Nessun download",
    "emptyHint": "Scarica contenuti per la visione offline",
    "paused": "In pausa"
  },
  "watchlist": {
    "filters": {
      "all": "Tutto",
      "continue": "Continua a guardare",
      "movies": "Film",
      "series": "Serie",
      "kids": "Bambini",
      "judaism": "Ebraismo",
      "podcasts": "Podcast",
      "radio": "Radio"
    },
    "title": "Lista",
    "items": "elementi",
    "watched": "[it] watched",
    "empty": "La tua lista è vuota",
    "emptyHint": "Inizia a guardare e gli elementi appariranno qui"
  },
  "widgets": {
    "empty": "[it] No widgets yet",
    "emptyHint": "[it] Your widgets will appear here",
    "emptyPersonal": "[it] No personal widgets yet",
    "emptyPersonalHint": "[it] Create your first personal widget or add system widgets above",
    "itemsTotal": "[it] total widgets",
    "systemWidgets": "[it] System Widgets",
    "systemWidgetsHint": "[it] Browse and add widgets to your collection",
    "myWidgets": "[it] My Personal Widgets",
    "myWidgetsHint": "[it] Widgets you have created",
    "personalWidgets": "[it] My Widgets",
    "noSystemWidgets": "[it] No system widgets available",
    "added": "[it] Added",
    "add": "[it] Add",
    "remove": "[it] Remove",
    "show": "[it] Show",
    "hidden": "[it] Hidden",
    "addToCollection": "[it] Add to My Widgets",
    "removeFromCollection": "[it] Remove from My Widgets",
    "contentTypes": {
      "liveChannel": "[it] Live Channel",
      "iframe": "[it] Web Content",
      "podcast": "[it] Podcast",
      "radio": "[it] Radio",
      "vod": "[it] Video",
      "custom": "[it] Custom",
      "widget": "[it] Widget"
    },
    "form": {
      "title": "[it] Create Widget",
      "basicInfo": "[it] Basic Information",
      "titlePlaceholder": "[it] Widget Title",
      "titleRequired": "[it] Widget Title is required",
      "descriptionPlaceholder": "[it] Description (optional)",
      "iconPlaceholder": "[it] Icon emoji (e.g., 📺)",
      "content": "[it] Content",
      "fromLibrary": "[it] From Library",
      "iframe": "[it] iFrame",
      "selectContent": "[it] Select Content (Channels, Podcasts, Shows, etc.)",
      "iframeUrl": "[it] iFrame URL",
      "iframeUrlRequired": "[it] iFrame URL is required",
      "iframeTitle": "[it] iFrame Title",
      "positionSize": "[it] Position & Size",
      "behavior": "[it] Behavior",
      "mutedByDefault": "[it] Muted by Default",
      "closable": "[it] Closable",
      "draggable": "[it] Draggable",
      "widgetOrder": "[it] Widget Order",
      "orderPlaceholder": "[it] Order (0 = first)",
      "saveWidget": "[it] Save Widget",
      "saving": "[it] Saving...",
      "cancel": "[it] Cancel",
      "change": "[it] Change"
    }
  },
  "trending": {
    "title": "[it] What's Trending in Israel",
    "noTopics": "[it] No trending topics available",
    "topStory": "[it] TOP STORY",
    "sources": "[it] Sources",
    "categories": {
      "security": "[it] Security",
      "politics": "[it] Politics",
      "tech": "[it] Tech",
      "culture": "[it] Culture",
      "sports": "[it] Sports",
      "economy": "[it] Economy",
      "entertainment": "[it] Entertainment",
      "weather": "[it] Weather",
      "health": "[it] Health",
      "general": "[it] General"
    }
  },
  "cultures": {
    "title": "Culture",
    "select": "Seleziona una cultura",
    "selectCulture": "Seleziona la tua cultura",
    "selectCultureDescription": "Scegli una cultura per personalizzare i tuoi contenuti",
    "changeCulture": "Cambia cultura",
    "israeli": {
      "name": "Israeliana",
      "description": "Contenuti per la comunità israeliana"
    },
    "chinese": {
      "name": "Cinese",
      "description": "Contenuti per la comunità cinese"
    },
    "japanese": {
      "name": "Giapponese",
      "description": "Contenuti per la comunità giapponese"
    },
    "korean": {
      "name": "Coreana",
      "description": "Contenuti per la comunità coreana"
    },
    "indian": {
      "name": "Indiana",
      "description": "Contenuti per la comunità indiana"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "Tendenze in {{location}}",
    "noTopics": "Nessun argomento di tendenza disponibile",
    "sources": "Fonti",
    "categories": {
      "security": "[it] Security",
      "politics": "[it] Politics",
      "tech": "[it] Tech",
      "technology": "[it] Technology",
      "culture": "[it] Culture",
      "sports": "[it] Sports",
      "economy": "[it] Economy",
      "finance": "[it] Finance",
      "entertainment": "[it] Entertainment",
      "weather": "[it] Weather",
      "health": "[it] Health",
      "food": "[it] Food",
      "fashion": "[it] Fashion",
      "travel": "[it] Travel",
      "history": "[it] History",
      "expat": "[it] Expat Life",
      "general": "[it] General"
    }
  },
  "cultureClock": {
    "timeIn": "Ora in {{location}}",
    "shabbat": "Shabbat",
    "weekend": "Fine settimana"
  },
  "cultureCities": {
    "connectionTo": "Connessione {{city}}",
    "explore": "[it] Explore {{city}}",
    "noContent": "Nessun contenuto disponibile",
    "categories": {
      "all": "Tutto",
      "history": "[it] History",
      "culture": "Cultura",
      "finance": "[it] Finance",
      "tech": "Tecnologia",
      "food": "Gastronomia",
      "expat": "[it] Expat Life",
      "news": "Notizie",
      "entertainment": "Intrattenimento"
    }
  },
  "clock": {
    "israel": "[it] Israel",
    "local": "[it] Local",
    "shabbatShalom": "[it] Shabbat Shalom!",
    "erevShabbat": "[it] Erev Shabbat",
    "candleLighting": "[it] Candle Lighting",
    "parasha": "[it] Parasha"
  },
  "ritual": {
    "title": "[it] Morning Ritual",
    "greeting": "[it] Good Morning!",
    "israelUpdate": "[it] It's afternoon in Israel, news is reporting on ongoing developments",
    "recommendation": "[it] We recommend starting with morning news then switching to radio",
    "preparingRitual": "[it] Preparing your morning ritual...",
    "israelTime": "[it] Israel Time",
    "day": "[it] Day",
    "letsStart": "[it] Let's Start",
    "skipToday": "[it] Skip for Today",
    "finish": "[it] Finish",
    "noContentNow": "[it] No content available right now",
    "typeLive": "[it] Live",
    "typeRadio": "[it] Radio",
    "typeVideo": "[it] Video"
  },
  "watchParty": {
    "title": "[it] Watch Party",
    "create": "[it] Create Party",
    "join": "[it] Join Party",
    "active": "[it] Party Active",
    "createTitle": "[it] Create Watch Party",
    "joinTitle": "[it] Join Party",
    "enterCode": "[it] Enter Room Code",
    "roomCode": "[it] Room Code",
    "copyCode": "[it] Copy Code",
    "codeCopied": "[it] Code Copied!",
    "participants": "[it] Participants",
    "host": "[it] Host",
    "you": "[it] You",
    "leave": "[it] Leave Party",
    "end": "[it] End Party",
    "chat": "[it] Chat",
    "sendMessage": "[it] Send Message",
    "typeMessage": "[it] Type a message...",
    "synced": "[it] Synced",
    "syncing": "[it] Syncing...",
    "hostPaused": "[it] Host Paused",
    "userJoined": "[it] {{name}} joined",
    "userLeft": "[it] {{name}} left",
    "partyEnded": "[it] The party has ended",
    "connecting": "[it] Connecting...",
    "options": {
      "chatEnabled": "[it] Enable Chat",
      "syncPlayback": "[it] Sync Playback"
    },
    "errors": {
      "invalidCode": "[it] Invalid code",
      "partyFull": "[it] Party is full",
      "partyEnded": "[it] Party has ended",
      "connectionError": "[it] Connection error",
      "createFailed": "[it] Failed to create party",
      "joinFailed": "[it] Failed to join party"
    },
    "audio": {
      "mute": "[it] Mute",
      "unmute": "[it] Unmute",
      "speaking": "[it] Speaking",
      "connecting": "[it] Connecting to audio...",
      "noAudio": "[it] Audio not available"
    },
    "textOnlyMode": "[it] Text Chat Only",
    "endParty": "[it] End Party"
  },
  "footer": {
    "brandDescription": "La tua casa negli USA. Trasmissioni TV, VOD, radio e podcast in ebraico.",
    "browse": "Sfoglia",
    "account": "Account",
    "support": "Supporto",
    "legal": "Legale",
    "location": "New York, USA",
    "links": {
      "home": "[it] Home",
      "liveTV": "[it] Live TV",
      "vod": "[it] Movies & Series",
      "radio": "[it] Radio",
      "podcasts": "[it] Podcasts",
      "judaism": "[it] Judaism",
      "profile": "[it] My Profile",
      "favorites": "[it] Favorites",
      "watchlist": "[it] Watchlist",
      "subscribe": "[it] Subscribe",
      "downloads": "[it] Downloads",
      "help": "[it] Help Center",
      "faq": "[it] FAQ",
      "contact": "[it] Contact Us",
      "feedback": "[it] Feedback",
      "terms": "[it] Terms of Service",
      "privacy": "[it] Privacy Policy",
      "cookies": "[it] Cookie Policy",
      "licenses": "[it] Licenses"
    },
    "newsletter": {
      "title": "[it] Stay Updated",
      "description": "[it] Subscribe to our newsletter for the latest updates and exclusive content.",
      "placeholder": "[it] Enter your email",
      "success": "[it] Thanks for subscribing!"
    },
    "apps": {
      "title": "[it] Get the App",
      "downloadOn": "[it] Download on",
      "getItOn": "[it] Get it on",
      "appStore": "[it] App Store",
      "googlePlay": "[it] Google Play"
    },
    "social": {
      "facebook": "[it] Facebook",
      "twitter": "[it] Twitter",
      "instagram": "[it] Instagram",
      "youtube": "[it] YouTube"
    },
    "copyright": "© {{year}} Bayit+. Tutti i diritti riservati.",
    "poweredBy": "Offerto da",
    "sitemap": "[it] Sitemap",
    "accessibility": "[it] Accessibility",
    "navigation": "[it] Navigation",
    "liveTV": "[it] Live TV",
    "moviesAndSeries": "[it] Movies & Series",
    "radioStations": "[it] Radio Stations",
    "myProfile": "[it] My Profile",
    "subscriptions": "[it] Subscriptions",
    "helpAndSupport": "[it] Help & Support",
    "termsOfUse": "[it] Terms of Use",
    "privacyPolicy": "[it] Privacy Policy",
    "contactUs": "[it] Contact Us"
  },
  "chapters": {
    "title": "[it] Chapters",
    "noChapters": "[it] No chapters available",
    "generating": "[it] Generating chapters...",
    "jumpTo": "[it] Jump to",
    "current": "[it] Now",
    "categories": {
      "intro": "[it] Introduction",
      "news": "[it] News",
      "security": "[it] Security",
      "politics": "[it] Politics",
      "economy": "[it] Economy",
      "sports": "[it] Sports",
      "weather": "[it] Weather",
      "culture": "[it] Culture",
      "conclusion": "[it] Conclusion"
    },
    "chapterLabel": "Capitolo {{number}}",
    "chapter_number": "Capitolo {{number}}"
  },
  "admin": {
    "brand": {
      "title": "Admin Bayit+",
      "subtitle": "Gestione sistema"
    },
    "backToApp": "Torna all'app",
    "refunds": {
      "subtitle": "Gestisci richieste di rimborso",
      "approveModal": {
        "title": "Conferma Approvazione",
        "message": "Approvare rimborso di {{amount}}?"
      },
      "confirmApprove": "Approvare rimborso di {{amount}}?",
      "confirmDelete": "Eliminare richiesta di rimborso?",
      "rejectModal": {
        "title": "Rifiuta Richiesta di Rimborso",
        "message": "Rifiuto rimborso di {{amount}}",
        "reasonLabel": "Motivo del Rifiuto",
        "reasonPlaceholder": "Inserisci il motivo del rifiuto...",
        "submitButton": "Rifiuta Richiesta"
      },
      "status": {
        "pending": "In Attesa",
        "approved": "Approvato",
        "rejected": "Rifiutato"
      },
      "columns": {
        "id": "ID",
        "user": "Utente",
        "amount": "Importo",
        "reason": "Motivo",
        "status": "Stato",
        "requestDate": "Data Richiesta"
      },
      "stats": {
        "pendingTitle": "In Attesa di Approvazione",
        "approvedTitle": "Approvati",
        "rejectedTitle": "Rifiutati",
        "totalRefunded": "Totale Rimborsato"
      },
      "emptyMessage": "Nessuna richiesta di rimborso trovata",
      "errors": {
        "rejectReasonRequired": "Inserisci il motivo del rifiuto"
      },
      "title": "Rimborsi"
    },
    "plans": {
      "title": "Gestione Piani",
      "subtitle": "Configura e gestisci i piani di abbonamento",
      "createButton": "Nuovo Piano",
      "inactive": "Inattivo",
      "subscribersLabel": "Abbonati:",
      "intervals": {
        "monthly": "mese",
        "yearly": "anno"
      },
      "trialDays": "{{days}} giorni di prova",
      "modal": {
        "editTitle": "Modifica Piano",
        "createTitle": "Nuovo Piano"
      },
      "form": {
        "nameEn": "Nome (Inglese)",
        "nameHe": "Nome (Ebraico)",
        "price": "Prezzo ($)",
        "interval": "Periodo di Fatturazione",
        "trialDays": "Giorni di Prova",
        "features": "Funzionalità (una per riga)",
        "active": "Piano Attivo"
      },
      "errors": {
        "requiredFields": "Nome e prezzo sono obbligatori"
      },
      "confirmDelete": "Eliminare il piano \"{{name}}\"?"
    },
    "emailCampaigns": {
      "subtitle": "Crea e gestisci campagne email",
      "createButton": "Nuova Campagna",
      "searchPlaceholder": "Cerca campagna...",
      "emptyMessage": "Nessuna campagna trovata",
      "status": {
        "draft": "Bozza",
        "active": "Attiva",
        "scheduled": "Programmata",
        "completed": "Completata"
      },
      "columns": {
        "name": "Nome Campagna",
        "status": "Stato",
        "sent": "Inviate",
        "opened": "Aperte",
        "clicked": "Cliccate",
        "created": "Creata",
        "actions": "Azioni"
      },
      "editModal": {
        "title": "Modifica Campagna"
      },
      "sendTestEmail": "Invia Test",
      "confirmSend": "Inviare la campagna \"{{name}}\"?",
      "confirmDelete": "Eliminare la campagna \"{{name}}\"?",
      "testEmailSent": "Email di test inviata!",
      "createModal": {
        "title": "Nuova Campagna Email"
      },
      "form": {
        "name": "Nome Campagna",
        "namePlaceholder": "es. Saldi di Fine Anno",
        "subject": "Oggetto Email",
        "subjectPlaceholder": "Oggetto mostrato ai destinatari",
        "body": "Contenuto",
        "bodyPlaceholder": "Contenuto email...",
        "submitButton": "Crea Campagna",
        "requiredFields": "Nome e oggetto sono obbligatori"
      },
      "testModal": {
        "title": "Invia Email di Test",
        "emailLabel": "Indirizzo Email",
        "emailPlaceholder": "test@example.com",
        "submitButton": "Invia Test"
      },
      "errors": {
        "requiredFields": "Nome e oggetto sono obbligatori"
      }
    },
    "dashboard": {
      "subtitle": "Panoramica del Sistema",
      "refresh": "Aggiorna",
      "timeAgo": {
        "minutes": "{{count}} minuti fa",
        "hours": "{{count}} ore fa"
      },
      "title": "Pannello di controllo",
      "users": "Utenti",
      "revenue": "Ricavi",
      "subscriptions": "Abbonamenti",
      "recentActivity": "Attività Recente",
      "quickActions": "Azioni Rapide"
    },
    "common": {
      "all": "Tutto",
      "cancel": "Annulla",
      "save": "Salva",
      "active": "Attivo",
      "back": "Indietro",
      "filterAction": "Azione",
      "filterResource": "Risorsa",
      "filterUser": "Utente",
      "filterDateRange": "Intervallo date"
    },
    "stats": {
      "totalUsers": "Utenti Totali",
      "activeUsers": "Utenti Attivi",
      "newToday": "Nuovi Oggi",
      "newThisWeek": "Nuovi Questa Settimana",
      "totalRevenue": "Ricavi Totali",
      "revenueToday": "Ricavi Oggi",
      "revenueMonth": "Ricavi Questo Mese",
      "arpu": "Ricavo medio per utente",
      "activeSubscriptions": "Abbonamenti Attivi",
      "churnRate": "Tasso di Abbandono"
    },
    "actions": {
      "new": "Nuovo",
      "addUser": "Aggiungi Utente",
      "newCampaign": "Nuova Campagna",
      "sendEmail": "Invia Email",
      "viewReports": "Visualizza Report"
    },
    "auditActions": {
      "user_created": "Utente Creato",
      "user_updated": "Utente Aggiornato",
      "user_deleted": "Utente Eliminato",
      "user_role_changed": "Ruolo Utente Modificato",
      "campaign_created": "Campagna Creata",
      "campaign_updated": "Campagna Aggiornata",
      "campaign_deleted": "Campagna Eliminata",
      "campaign_activated": "Campagna Attivata",
      "subscription_created": "Abbonamento Creato",
      "subscription_updated": "Abbonamento Aggiornato",
      "subscription_canceled": "Abbonamento Cancellato",
      "subscription_deleted": "Abbonamento Eliminato",
      "refund_processed": "Rimborso Elaborato",
      "payment_received": "Pagamento Ricevuto",
      "settings_updated": "Impostazioni Aggiornate",
      "login": "Accesso",
      "logout": "Disconnessione",
      "content_created": "Contenuto Creato",
      "content_updated": "Contenuto Aggiornato",
      "content_deleted": "Contenuto Eliminato",
      "content_published": "Contenuto Pubblicato",
      "content_unpublished": "Contenuto Rimosso dalla Pubblicazione",
      "category_created": "Categoria Creata",
      "category_updated": "Categoria Aggiornata",
      "category_deleted": "Categoria Eliminata",
      "live_channel_created": "Canale Live Creato",
      "live_channel_updated": "Canale Live Aggiornato",
      "live_channel_deleted": "Canale Live Eliminato",
      "radio_station_created": "Stazione Radio Creata",
      "radio_station_updated": "Stazione Radio Aggiornata",
      "radio_station_deleted": "Stazione Radio Eliminata",
      "podcast_created": "Podcast Creato",
      "podcast_updated": "Podcast Aggiornato",
      "podcast_deleted": "Podcast Eliminato",
      "podcast_episode_created": "Episodio Podcast Creato",
      "podcast_episode_updated": "Episodio Podcast Aggiornato",
      "podcast_episode_deleted": "Episodio Podcast Eliminato",
      "content_imported": "Contenuto Importato",
      "widget_created": "Widget Creato",
      "widget_updated": "Widget Aggiornato",
      "widget_deleted": "Widget Eliminato",
      "widget_published": "Widget Pubblicato",
      "widget_unpublished": "Widget Rimosso dalla Pubblicazione"
    },
    "placeholder": {
      "userId": "Inserisci ID utente",
      "discount": "0"
    },
    "titles": {
      "users": "Utenti",
      "transactions": "Transazioni",
      "subscriptions": "Abbonamenti",
      "refunds": "Rimborsi",
      "plans": "Piani",
      "campaigns": "Campagne",
      "auditLogs": "Log di Audit",
      "pushNotifications": "Notifiche Push",
      "billing": "Fatturazione",
      "marketing": "Marketing",
      "content": "Libreria Contenuti",
      "categories": "Categorie",
      "liveChannels": "Canali Live",
      "radioStations": "Stazioni Radio",
      "podcasts": "Podcast",
      "settings": "Impostazioni"
    },
    "nav": {
      "dashboard": "Pannello di controllo",
      "users": "Utenti",
      "campaigns": "Campagne",
      "billing": "Fatturazione",
      "billingOverview": "Panoramica",
      "transactions": "Transazioni",
      "refunds": "Rimborsi",
      "subscriptions": "Abbonamenti",
      "subscriptionsList": "Abbonati",
      "plans": "Piani",
      "marketing": "Marketing",
      "marketingDashboard": "Panoramica",
      "emailCampaigns": "Campagne Email",
      "pushNotifications": "Notifiche Push",
      "content": "Contenuti",
      "contentLibrary": "Libreria Contenuti",
      "categories": "Categorie",
      "liveChannels": "Canali Live",
      "radioStations": "Stazioni Radio",
      "podcasts": "Podcast",
      "widgets": "Widget",
      "recordings": "Registrazioni",
      "uploads": "Caricamenti",
      "settings": "Impostazioni",
      "auditLogs": "Log di Audit",
      "librarian": "Agente Bibliotecario",
      "featured": "In Evidenza"
    },
    "featured": {
      "title": "Contenuti in Evidenza",
      "subtitle": "Gestisci i contenuti in evidenza per i carousel della home",
      "empty": "Nessun contenuto in evidenza",
      "emptyHint": "Gli elementi in evidenza appariranno nei rispettivi carousel sulla homepage",
      "count": "{{count}} elementi",
      "confirmUnfeature": "Rimuovere dai contenuti in evidenza?",
      "remove": "Rimuovi",
      "unsavedChanges": "Hai modifiche non salvate",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}} elemento",
        "itemCount_plural": "{{count}} elementi",
        "empty": "Nessun elemento in evidenza",
        "emptyHint": "Gli elementi in evidenza appariranno nel carousel {{name}} sulla homepage"
      },
      "saveButton": "Salva {{count}} Sezione",
      "saveButton_plural": "Salva {{count}} Sezioni",
      "saving": "Salvataggio...",
      "saveSuccess": "Contenuti in evidenza aggiornati con successo",
      "saveFailed": "Impossibile salvare i contenuti in evidenza",
      "removeConfirm": "Rimuovere da {{section}}?",
      "removeSuccess": "Rimosso da {{section}}"
    },
    "recordings": {
      "title": "Gestione Registrazioni",
      "subtitle": "Gestisci le registrazioni degli utenti sulla piattaforma",
      "totalRecordings": "Registrazioni Totali",
      "totalStorage": "Spazio Totale",
      "totalUsers": "Utenti con Registrazioni",
      "activeSessions": "Sessioni Attive",
      "searchPlaceholder": "Cerca per titolo, utente o canale...",
      "user": "Utente",
      "confirmDelete": "Eliminare la registrazione '{{title}}'? Questa azione non può essere annullata.",
      "deleteRecording": "Elimina Registrazione",
      "deleteSuccess": "Registrazione eliminata con successo",
      "deleteFailed": "Impossibile eliminare la registrazione",
      "loadFailed": "Impossibile caricare le registrazioni",
      "noRecordings": "Nessuna Registrazione Trovata",
      "noRecordingsHint": "Ancora nessuna registrazione utente nel sistema."
    },
    "uploads": {
      "title": "Gestione Caricamenti",
      "subtitle": "Gestisci i caricamenti di contenuti e il monitoraggio automatico delle cartelle",
      "activeUploads": "Caricamenti Attivi",
      "noActiveUploads": "Nessun caricamento attivo",
      "queuedUploads": "Caricamenti in Coda",
      "queued": "In Coda",
      "andMore": "E altri {{count}}",
      "monitoredFolders": "Cartelle Monitorate",
      "noMonitoredFolders": "Nessuna cartella monitorata configurata",
      "configureFoldersHelp": "Clicca 'Aggiungi Cartella' per configurare le cartelle monitorate per caricamenti automatici",
      "addFolder": "Aggiungi Cartella",
      "editFolder": "Modifica Cartella",
      "deleteFolder": "Elimina Cartella",
      "confirmDelete": "Eliminare questa cartella?",
      "triggerUpload": "Avvia Caricamento",
      "triggerUploadSuccess": "Trovati {{files_found}} nuovi file da caricare",
      "triggerUploadFailed": "Impossibile avviare la scansione di caricamento",
      "noFilesFound": "Nessun nuovo file trovato nelle cartelle monitorate",
      "sessionIssue": "Problema di Sessione",
      "sessionIssueHelp": "La tua sessione potrebbe essere scaduta. Aggiorna la pagina per ripristinare la connessione.",
      "sessionExpired": "Sessione scaduta. Aggiorna la pagina o accedi nuovamente.",
      "unauthorized": "Sessione non valida. Aggiorna la pagina.",
      "endpointNotFound": "Servizio di caricamento non disponibile. Verifica la configurazione del server.",
      "timeout": "Scansione di caricamento scaduta. Riprova o verifica le cartelle monitorate.",
      "wsDisconnected": "Aggiornamenti in Tempo Reale Disabilitati",
      "wsDisconnectedHelp": "Connessione WebSocket fallita. Lo stato della coda potrebbe non essere aggiornato. La pagina ritenterà automaticamente.",
      "wsReconnecting": "Riconnessione agli aggiornamenti in tempo reale...",
      "uploadAlreadyRunning": "Scansione di caricamento già in corso. Attendi il completamento dei caricamenti correnti.",
      "uploadsActiveNotice": "Caricamenti in corso ({{processing}} attivi, {{queued}} in coda). Nuova scansione disabilitata fino al completamento del batch corrente.",
      "clearQueue": "Svuota Coda",
      "clearQueueConfirmTitle": "Svuotare la Coda di Caricamento?",
      "clearQueueConfirmMessage": "Questo annullerà {{count}} job attivi. Questa azione non può essere annullata.",
      "clearQueueSuccess": "Coda svuotata con successo",
      "clearQueueFailed": "Impossibile svuotare la coda",
      "cancelUpload": "Annulla",
      "cancelUploadConfirm": "Annullare questo caricamento?",
      "cancelUploadSuccess": "Caricamento annullato",
      "cancelUploadFailed": "Impossibile annullare il caricamento",
      "resetCache": "Reimposta Cache",
      "cacheResetSuccess": "Cache svuotata: {{count}} file verranno riscansionati alla prossima scansione",
      "cacheResetFailed": "Impossibile reimpostare la cache",
      "contentTypeFilters": "Filtri Tipo Contenuto",
      "contentTypeFiltersHelp": "Opzionale - Lascia tutti deselezionati per elaborare tutti i tipi di contenuto",
      "moviesOnly": "Solo Film",
      "seriesOnly": "Solo Serie",
      "audiobooksOnly": "Solo Audiolibri",
      "type": "Tipo",
      "lastScan": "Ultima scansione",
      "systemInfo": "Informazioni Sistema di Caricamento",
      "systemInfoText": "Estrae automaticamente i sottotitoli dai file video locali durante il caricamento per un'elaborazione più veloce",
      "languagesInfo": "Lingue sottotitoli supportate: Inglese (en), Ebraico (he), Spagnolo (es)",
      "queueStatus": "Coda di Caricamento",
      "totalJobs": "Totale",
      "processing": "Attivi",
      "completed": "Completati",
      "skipped": "Saltati",
      "failed": "Falliti",
      "queuePaused": "Coda in Pausa",
      "resumeQueue": "Riprendi",
      "activeUpload": "Caricamento Attivo",
      "queuedItems": "In Coda",
      "noQueuedItems": "Nessun elemento in coda",
      "addedAt": "Aggiunto",
      "recentCompleted": "Completati di Recente",
      "stages": {
        "browserUpload": "Caricamento sul server",
        "hashCalculation": "Calcolo hash",
        "duplicateCheck": "Verifica duplicati",
        "metadataExtraction": "Estrazione metadati",
        "gcsUpload": "Caricamento sul cloud",
        "databaseInsert": "Salvataggio nel database",
        "imdbLookup": "Recupero info IMDB",
        "subtitleExtraction": "Estrazione sottotitoli",
        "completed": "Completato",
        "failed": "Fallito",
        "skipped": "Saltato"
      },
      "form": {
        "name": "Nome Cartella",
        "namePlaceholder": "La mia Cartella Film",
        "path": "Percorso Cartella",
        "pathHelp": "Inserisci il percorso del server alla cartella (es. /Volumes/USB Drive/Movies)",
        "contentType": "Tipo Contenuto",
        "enabled": "Abilitato",
        "autoUpload": "Caricamento Automatico"
      },
      "contentTypes": {
        "movie": "Film",
        "series": "Serie",
        "audiobook": "Audiolibri"
      },
      "errors": {
        "pathRequired": "Il percorso della cartella è obbligatorio"
      },
      "manualUpload": {
        "title": "Caricamento Manuale",
        "subtitle": "Trascina e rilascia file o seleziona una cartella",
        "dropHere": "Rilascia i file qui o clicca per sfogliare",
        "dropHereActive": "Rilascia i file per aggiungerli",
        "selectFolder": "Seleziona Cartella",
        "supportedFormats": "Supporta file video (mp4, mkv, avi, mov, webm)",
        "selectedFiles": "File Selezionati",
        "noFilesSelected": "Nessun file selezionato",
        "clearAll": "Cancella Tutto",
        "uploadSelected": "Carica Selezionati",
        "selectContentType": "Seleziona il tipo di contenuto per il caricamento",
        "uploadingFiles": "Aggiunta di {{count}} file alla coda...",
        "uploadSuccess": "Aggiunti con successo {{count}} file alla coda",
        "uploadFailed": "Impossibile aggiungere file alla coda",
        "fileSize": "Dimensione",
        "removeFile": "Rimuovi",
        "invalidFileType": "Tipo di file non valido. Solo file video sono supportati.",
        "filesCount": "{{count}} file selezionati",
        "pendingRestore": "{{count}} file in attesa dalla sessione precedente",
        "pendingRestoreHint": "Rilascia o seleziona gli stessi file per ripristinare la coda di caricamento"
      }
    },
    "librarian": {
      "title": "Agente Bibliotecario",
      "subtitle": "Gestione autonoma della libreria contenuti basata su IA",
      "loading": "Caricamento Agente Bibliotecario...",
      "loadingConfig": "Caricamento configurazione...",
      "refresh": "Aggiorna",
      "errors": {
        "configError": "Errore di Configurazione",
        "configNotLoaded": "Configurazione non caricata",
        "failedToLoad": "Impossibile caricare i dati del bibliotecario",
        "failedToLoadConfig": "Impossibile caricare la configurazione del bibliotecario",
        "failedToTrigger": "Impossibile avviare l'audit. Riprova.",
        "failedToLoadDetails": "Impossibile caricare i dettagli del report.",
        "failedToRollback": "Impossibile annullare l'azione.",
        "failedToClearReports": "Impossibile cancellare i report di audit. Riprova.",
        "failedToPause": "Impossibile mettere in pausa l'audit",
        "failedToResume": "Impossibile riprendere l'audit",
        "failedToCancel": "Impossibile annullare l'audit",
        "failedToInterject": "Impossibile inviare messaggio all'agente IA",
        "auditAlreadyRunning": "Un audit è già in corso. Attendi il completamento o annullalo prima di avviarne uno nuovo.",
        "budgetExceeded": "Limite budget mensile superato. Impossibile eseguire l'audit.",
        "contactAdmin": "La pagina Bibliotecario non può caricarsi senza una configurazione corretta.\nContatta il tuo amministratore."
      },
      "stats": {
        "systemHealth": "Stato del Sistema",
        "totalAudits": "Audit Totali (30g)",
        "last30Days": "Ultimi 30 giorni",
        "issuesFixed": "Problemi Risolti",
        "lastAudit": "Ultimo Audit",
        "never": "Mai",
        "unknown": "sconosciuto"
      },
      "health": {
        "excellent": "eccellente",
        "good": "buono",
        "fair": "discreto",
        "poor": "scarso",
        "unknown": "sconosciuto"
      },
      "quickActions": {
        "title": "Configurazione Esecuzione",
        "subtitle": "Configura e avvia gli audit",
        "auditMode": "Modalità Audit",
        "auditModeHelp": "Scegli cosa verificare",
        "dryRun": "Modalità Anteprima",
        "dryRunHelp": "Mostra cosa cambierebbe senza apportare modifiche",
        "scopeFilters": "Capacità Audit",
        "scopeFiltersHelp": "Seleziona le capacità da abilitare (è possibile combinarne più di una)",
        "last24Hours": "Solo Contenuti Recenti",
        "last24HoursHelp": "Limita l'audit ai contenuti aggiunti nelle ultime 24 ore",
        "cybTitlesOnly": "Pulisci Titoli Sporchi",
        "cybTitlesOnlyHelp": "Rimuovi estensioni file, marcatori di qualità e tag di release dai titoli",
        "tmdbPostersOnly": "Poster e Metadati TMDB",
        "tmdbPostersOnlyHelp": "Recupera poster, descrizioni e metadati mancanti da TMDB",
        "openSubtitlesEnabled": "Acquisisci Sottotitoli",
        "openSubtitlesEnabledHelp": "Scarica sottotitoli mancanti da OpenSubtitles (HE/EN/ES)",
        "classifyOnly": "Verifica Classificazione",
        "classifyOnlyHelp": "Controlla e correggi errori di classificazione film vs serie",
        "purgeDuplicates": "Rimuovi Duplicati",
        "purgeDuplicatesHelp": "Trova e rimuovi elementi di contenuto duplicati",
        "auditType": "Tipo di Audit",
        "auditTypeHelp": "Scegli tra audit basato su regole o basato su IA",
        "dailyAudit": "Audit Giornaliero",
        "dailyBadge": "Basato su Regole • Veloce • Gratuito",
        "dailyDescription": "Esegue controlli predefiniti sui contenuti modificati negli ultimi 7 giorni. Veloce e prevedibile, nessun costo IA.",
        "aiAgentAudit": "Audit Agente IA",
        "aiAgentBadge": "Basato su IA • Intelligente • Usa Budget",
        "aiAgentDescription": "L'agente IA autonomo (Claude) prende decisioni intelligenti su cosa controllare e correggere. Più completo ma utilizza il budget API.",
        "triggerDaily": "Esegui Audit Giornaliero",
        "triggerAI": "Esegui Audit Agente IA",
        "auditRunningNotice": "Un audit è attualmente in esecuzione. I pulsanti saranno abilitati al completamento.",
        "budgetLabel": "Limite Budget Agente IA: ${{budget}}",
        "budgetPerAudit": "Budget per audit",
        "monthlyBudgetUsed": "Budget Utilizzato (30g)",
        "monthlyBudgetLimit": "/ ${{limit}} mensile",
        "budgetWarning": "L'esecuzione di questo audit supererebbe il limite di budget mensile",
        "aiAuditSuccess": "Audit Agente IA avviato con successo. {{dryRun}}",
        "dailyAuditSuccess": "Audit giornaliero avviato con successo. {{dryRun}}",
        "dryRunMode": "(Modalità anteprima)",
        "rollbackSuccess": "Azione annullata con successo."
      },
      "voice": {
        "title": "Controllo Vocale",
        "description": "Usa la tua voce per dare comandi al bibliotecario. Premi semplicemente il pulsante e parla naturalmente.",
        "pressToSpeak": "Premi per Parlare",
        "listening": "In ascolto...",
        "transcript": "Trascrizione",
        "processing": "Elaborazione del tuo comando...",
        "speaking": "Il bibliotecario sta rispondendo...",
        "examples": "Comandi di Esempio",
        "example1": "Controlla i poster mancanti nelle ultime 24 ore",
        "example2": "Correggi i metadati per i titoli CYB",
        "example3": "Cerca URL di streaming non funzionanti",
        "example4": "Estrai sottotitoli dai film",
        "notSupported": "Il riconoscimento vocale non è supportato nel tuo browser. Usa Chrome, Edge o Safari.",
        "notAvailable": "Il controllo vocale non è disponibile",
        "noSpeech": "Nessun discorso rilevato. Riprova.",
        "noMicrophone": "Nessun microfono rilevato. Verifica il tuo dispositivo.",
        "microphoneBlocked": "L'accesso al microfono è stato bloccato. Abilitalo nelle impostazioni del browser.",
        "error": "Errore riconoscimento vocale: {{error}}",
        "startFailed": "Impossibile avviare il riconoscimento vocale. Riprova.",
        "commandFailed": "Impossibile eseguire il comando. Riprova."
      },
      "schedules": {
        "title": "Audit Programmati",
        "subtitle": "Configura gli audit giornalieri e settimanali programmati",
        "dailyTitle": "Audit Giornaliero",
        "weeklyTitle": "Audit IA Settimanale",
        "schedule": "Programma",
        "time": "Ora",
        "mode": "Modalità",
        "cost": "Costo Stim.",
        "status": "Stato",
        "description": "Descrizione",
        "viewInConsole": "Visualizza in Cloud Console",
        "modifyNote": "Per modificare le programmazioni, usa Google Cloud Console",
        "editTitle": "Modifica Programmazione",
        "editNotAvailable": "Modifica Programmazione Non Disponibile",
        "editNotAvailableMessage": "Le modifiche alla programmazione richiedono l'integrazione con Cloud Scheduler API. Usa il pulsante 'Visualizza in Cloud Console' per modificare le programmazioni direttamente in Google Cloud Console.",
        "cronExpression": "Espressione Cron",
        "cronHint": "Formato: minuto ora giorno mese giorno_settimana (es. 0 2 * * * = giornaliero alle 2:00)",
        "patterns": {
          "daily": "Giornaliero alle {{hour}}:{{minute}}",
          "weekly": "Ogni {{day}} alle {{hour}}:{{minute}}"
        },
        "days": {
          "sunday": "Domenica",
          "monday": "Lunedì",
          "tuesday": "Martedì",
          "wednesday": "Mercoledì",
          "thursday": "Giovedì",
          "friday": "Venerdì",
          "saturday": "Sabato"
        }
      },
      "reports": {
        "title": "Report Audit Recenti",
        "emptyMessage": "Nessun report di audit ancora",
        "totalReports": "{{count}} report",
        "clearAll": "Cancella Tutto",
        "confirmClearAll": "Sei sicuro di voler cancellare tutti i report di audit? Questa azione non può essere annullata.",
        "clearedSuccessfully": "Tutti i report di audit cancellati con successo",
        "viewLogs": "Visualizza Log",
        "viewDetails": "Visualizza Dettagli",
        "columns": {
          "date": "Data",
          "type": "Tipo",
          "duration": "Durata",
          "status": "Stato",
          "issues": "Problemi",
          "fixes": "Correzioni",
          "actions": "Azioni"
        },
        "detailModal": {
          "title": "Report Audit: {{id}}",
          "summary": "Riepilogo",
          "status": "Stato",
          "executionTime": "Tempo di Esecuzione",
          "totalItems": "Elementi Totali",
          "healthyItems": "Elementi Sani",
          "issuesFound": "Problemi Trovati",
          "totalIssues": "Problemi Totali Trovati",
          "seeInsightsBelow": "Vedi Approfondimenti IA sotto per i dettagli",
          "brokenStreams": "Stream Non Funzionanti",
          "missingMetadata": "Metadati Mancanti",
          "misclassifications": "Classificazioni Errate",
          "orphanedItems": "Elementi Orfani",
          "fixesApplied": "Correzioni Applicate",
          "totalFixes": "{{count}} correzioni totali",
          "aiInsights": "Approfondimenti IA"
        }
      },
      "logs": {
        "title": "Log di Esecuzione",
        "liveAuditLog": "Log Audit in Tempo Reale",
        "executionLog": "Log Esecuzione Audit",
        "searchPlaceholder": "Cerca nei log...",
        "noLogs": "Nessun log da visualizzare",
        "noActiveAudit": "Nessun Audit Attivo",
        "triggerAuditToSee": "Avvia un audit per vedere i log di esecuzione in tempo reale qui",
        "auditType": "Tipo Audit",
        "started": "Iniziato",
        "completed": "Completato",
        "lastLog": "Ultimo log",
        "staleWarning": "Nessun nuovo log da {{seconds}}s - il job potrebbe essere in elaborazione o bloccato",
        "pollingStatus": "Polling attivo • Ultimo controllo",
        "connecting": "Connessione al log audit in tempo reale...",
        "aiInsightPrefix": "Approfondimento IA",
        "source": {
          "librarian": "Bibliotecario",
          "aiAgent": "Agente IA"
        },
        "levels": {
          "debug": "DEBUG",
          "info": "INFO",
          "warn": "AVVISO",
          "error": "ERRORE",
          "success": "SUCCESSO",
          "trace": "TRACCIA"
        },
        "auditStarted": "Audit avviato",
        "brokenStreamsFound": "Trovati {{count}} stream non funzionanti",
        "missingMetadataFound": "Trovati {{count}} elementi con metadati mancanti",
        "misclassificationsFound": "Trovati {{count}} elementi classificati erroneamente",
        "orphanedItemsFound": "Trovati {{count}} elementi orfani",
        "fixesApplied": "Applicate {{count}} correzioni",
        "auditCompleted": "Audit {{status}} in {{duration}}s",
        "auditInitializing": "Inizializzazione audit {{auditType}}...",
        "dryRunMode": "Esecuzione in modalità ANTEPRIMA - nessuna modifica verrà apportata",
        "liveMode": "Esecuzione in modalità LIVE - le modifiche verranno applicate",
        "budgetSet": "Limite budget: ${{budget}}",
        "connectingToAgent": "Connessione all'Agente IA Claude..."
      },
      "audit": {
        "types": {
          "aiAgent": "Agente IA",
          "dailyIncremental": "Incrementale Giornaliero"
        },
        "pause": "Pausa",
        "resume": "Riprendi",
        "cancel": "Annulla",
        "interject": "Interrompi",
        "interjectTitle": "Invia Messaggio all'Agente IA",
        "interjectHint": "Questo messaggio verrà inserito nella conversazione dell'agente IA alla prossima iterazione. Usalo per fornire contesto aggiuntivo, reindirizzare l'attenzione o dare istruzioni specifiche.",
        "interjectPlaceholder": "es. Concentrati solo sui film, salta le serie per ora...",
        "sendInterject": "Invia",
        "interjectSuccess": "Messaggio inviato all'agente IA con successo",
        "pauseSuccess": "Audit messo in pausa con successo",
        "resumeSuccess": "Audit ripreso con successo",
        "cancelSuccess": "Audit annullato con successo"
      },
      "progress": {
        "batch": "Batch {{current}} di {{total}}",
        "items": "{{processed}} di {{total}} elementi",
        "finishing": "Completamento...",
        "finalizing": "Generazione report e applicazione correzioni"
      },
      "activityLog": {
        "title": "Log Attività",
        "subtitle": "{{count}} azioni registrate",
        "filterByType": "Filtra per tipo",
        "allActions": "Tutte le Azioni",
        "content": "Contenuto",
        "noDescription": "Nessuna descrizione disponibile",
        "updatedFields": "Aggiornati {{fields}}",
        "pagination": "Pagina {{page}} di {{totalPages}}",
        "issueType": "Tipo Problema",
        "confidence": "Affidabilità",
        "autoApproved": "Auto-approvato",
        "changes": "Modifiche",
        "actionTypes": {
          "addPoster": "Aggiungi Poster",
          "updateMetadata": "Aggiorna Metadati",
          "recategorize": "Ricategorizza",
          "fixUrl": "Correggi URL",
          "cleanTitle": "Pulisci Titolo",
          "classify": "Classifica"
        },
        "rollback": "Annulla",
        "rolledBack": "Annullato",
        "confirmRollback": {
          "title": "Conferma Annullamento",
          "message": "Sei sicuro di voler annullare questa azione? Questo ripristinerà lo stato precedente."
        },
        "emptyMessage": "Nessuna azione trovata"
      },
      "modal": {
        "confirmAI": {
          "title": "Avviare l'Audit Agente IA?",
          "message": "Questo avvierà un audit autonomo dell'agente IA con un limite di budget di ${{budget}}. L'agente prenderà decisioni su cosa controllare e correggere. {{dryRun}}",
          "dryRunNote": "Esecuzione in modalità ANTEPRIMA (nessuna modifica verrà apportata)."
        },
        "cancel": "Annulla",
        "confirm": "Conferma",
        "close": "Chiudi",
        "retry": "Riprova"
      },
      "status": {
        "enabled": "ABILITATO",
        "disabled": "DISABILITATO",
        "completed": "Audit Completato",
        "failed": "Audit Fallito",
        "in_progress": "In Corso",
        "partial": "Parzialmente Completato",
        "pending": "In Attesa",
        "running": "In Esecuzione"
      },
      "auditTypes": {
        "daily_incremental": "incrementale giornaliero",
        "ai_agent": "Agente IA"
      }
    },
    "widgets": {
      "title": "Widget",
      "subtitle": "Gestisci widget overlay flottanti per stream live ed embed",
      "newWidget": "Nuovo Widget",
      "editWidget": "Modifica Widget",
      "columns": {
        "title": "Titolo",
        "contentType": "Tipo Contenuto",
        "targetRoles": "Ruoli Target",
        "targetPages": "Pagine Target",
        "status": "Stato",
        "order": "Ordine"
      },
      "contentTypes": {
        "liveChannel": "Canale Live",
        "live": "In diretta",
        "vod": "Video on demand",
        "podcast": "Podcast",
        "radio": "Radio",
        "iframe": "Iframe"
      },
      "status": {
        "active": "Attivo",
        "inactive": "Inattivo"
      },
      "form": {
        "title": "Titolo widget",
        "description": "Descrizione (opzionale)",
        "icon": "Emoji icona (opzionale)",
        "contentType": "Tipo Contenuto",
        "selectChannel": "Seleziona Canale Live",
        "channelPlaceholder": "-- Seleziona Canale --",
        "iframeUrl": "URL Iframe",
        "iframeTitle": "Titolo iframe (per accessibilità)",
        "position": "Posizione Predefinita",
        "behavior": "Comportamento",
        "mutedByDefault": "Silenziato per default",
        "closable": "Chiudibile",
        "draggable": "Trascinabile",
        "targetPages": "Pagine Target (separate da virgola, vuoto = tutte)",
        "targetPagesPlaceholder": "/, /live, /vod",
        "order": "Ordine"
      },
      "actions": {
        "save": "Salva",
        "cancel": "Annulla"
      },
      "confirmDelete": "Sei sicuro di voler eliminare questo widget?",
      "emptyMessage": "Nessun widget trovato. Creane uno per iniziare.",
      "allPages": "Tutte le pagine",
      "allRoles": "Tutti",
      "errors": {
        "titleRequired": "Il titolo è obbligatorio",
        "selectChannel": "Seleziona un canale live",
        "iframeUrlRequired": "L'URL dell'iframe è obbligatorio"
      }
    },
    "billing": {
      "subtitle": "Monitora ricavi e pagamenti",
      "revenue": "Ricavi",
      "today": "Oggi",
      "thisWeek": "Questa Settimana",
      "thisMonth": "Questo Mese",
      "thisYear": "Quest'Anno",
      "metrics": "Metriche Chiave",
      "totalTransactions": "Transazioni Totali",
      "avgTransaction": "Transazione Media",
      "pendingRefunds": "Rimborsi in Attesa",
      "refundRate": "Tasso di Rimborso",
      "retention": "Fidelizzazione",
      "retentionRate": "Tasso di Fidelizzazione",
      "churnRate": "Tasso di Abbandono",
      "atRiskUsers": "Utenti a Rischio",
      "churnedUsers": "Utenti Persi",
      "quickLinks": "Link Rapidi"
    },
    "marketing": {
      "recentCampaigns": "Campagne Recenti",
      "audienceSegments": "Segmenti di Pubblico",
      "emailMetrics": "Metriche Email",
      "pushMetrics": "Metriche Push",
      "quickActions": "Azioni Rapide"
    },
    "push": {
      "titlePlaceholder": "Titolo Notifica",
      "bodyPlaceholder": "Messaggio Notifica"
    },
    "auditLogs": {
      "subtitle": "Traccia tutte le azioni di sistema",
      "filter": "Filtra",
      "export": "Esporta",
      "all": "Tutto",
      "advancedFiltering": "Filtro Avanzato",
      "actionType": "Tipo Azione",
      "clear": "Cancella",
      "apply": "Applica",
      "noRecords": "Nessun record trovato",
      "columns": {
        "action": "Azione",
        "user": "Utente",
        "resource": "Risorsa",
        "details": "Dettagli",
        "date": "Data",
        "ip": "IP"
      },
      "changed": "Modificato",
      "actionFilters": {
        "user": "Utente",
        "subscription": "Abbonamento",
        "payment": "Pagamento",
        "settings": "Impostazioni",
        "campaign": "Campagna",
        "content": "Contenuto"
      }
    },
    "settings": {
      "subtitle": "Configura i parametri di sistema",
      "saveChanges": "Salva Modifiche",
      "generalSettings": "Impostazioni Generali",
      "supportEmail": "Email Supporto",
      "defaultPlan": "Piano Predefinito",
      "termsUrl": "URL Termini di Servizio",
      "privacyUrl": "URL Privacy Policy",
      "userSettings": "Impostazioni Utente",
      "maxDevices": "Dispositivi Massimi per Account",
      "trialDays": "Giorni Periodo di Prova",
      "maintenanceMode": "Modalità Manutenzione",
      "maintenanceModeDesc": "Quando abilitata, il sistema sarà inaccessibile agli utenti",
      "featureFlags": "Feature Flag",
      "systemActions": "Azioni di Sistema",
      "clearCache": "Svuota Cache",
      "resetAnalytics": "Reimposta Analytics",
      "actionsWarning": "Queste azioni potrebbero influire sulle prestazioni del sistema. Usa con cautela.",
      "savingSuccess": "Impostazioni salvate con successo",
      "confirmClearCache": "Svuotare la cache? Potrebbe influire temporaneamente sulle prestazioni.",
      "cacheCleared": "Cache svuotata con successo",
      "confirmResetAnalytics": "Reimpostare i dati di analytics? Questa azione non può essere annullata!",
      "analyticsReset": "I dati di analytics sono stati reimpostati",
      "featureFlagLabels": {
        "new_player": "Nuovo Player",
        "live_chat": "Chat Live",
        "downloads": "Download",
        "watch_party": "Watch Party",
        "voice_search": "Ricerca Vocale",
        "ai_recommendations": "Raccomandazioni IA"
      }
    },
    "content": {
      "title": "Libreria Contenuti",
      "subtitle": "Gestisci film, serie e contenuti video",
      "importFree": "Importa Contenuti Gratuiti",
      "searchPlaceholder": "Cerca contenuti...",
      "emptyMessage": "Nessun contenuto trovato",
      "confirmDelete": "Eliminare questo contenuto?",
      "confirmBatchDelete": "Sei sicuro di voler eliminare {{count}} elementi?",
      "selectedItems": "{{count}} elementi selezionati",
      "batchFeature": "Metti in Evidenza",
      "batchUnfeature": "Rimuovi da Evidenza",
      "import": {
        "pageTitle": "Importa Contenuti Gratuiti",
        "subtitle": "Sfoglia e importa contenuti pubblici da fonti gratuite",
        "selectCategory": "Seleziona categoria per i film importati:",
        "categoryPlaceholder": "Seleziona una categoria...",
        "loading": "Caricamento fonti...",
        "sourceTypes": {
          "vod": "Film e VOD",
          "live_tv": "TV Live",
          "radio": "Radio",
          "podcasts": "Podcast"
        },
        "items": "elemento",
        "itemsPlural": "elementi",
        "selectItems": "Seleziona almeno un elemento da importare",
        "selectCategory_vod": "Seleziona una categoria per le importazioni VOD",
        "importing": "Importazione {{count}}... {{percent}}%",
        "importButton": "Importa {{count}} {{item}}",
        "noSources": "Nessuna Fonte Disponibile",
        "noSourcesDescription": "Nessuna fonte di contenuti gratuiti attualmente disponibile per {{type}}"
      },
      "filters": {
        "title": "Filtri",
        "contentType": "Tipo Contenuto",
        "all": "Tutto",
        "allContent": "Tutto",
        "series": "Serie",
        "movies": "Film",
        "podcasts": "Podcast",
        "radioStations": "Stazioni Radio",
        "status": "Stato",
        "allStatus": "Tutti gli Stati",
        "subtitles": "Sottotitoli"
      },
      "podcastsComingSoon": "Gestione podcast in arrivo. Usa la sezione Podcast.",
      "radioComingSoon": "Gestione stazioni radio in arrivo. Usa la sezione Stazioni Radio.",
      "showOnlyWithSubtitles": "Mostra solo con sottotitoli",
      "status": {
        "published": "Pubblicato",
        "draft": "Bozza"
      },
      "columns": {
        "title": "Titolo",
        "category": "Categoria",
        "year": "Anno",
        "status": "Stato",
        "views": "Visualizzazioni",
        "rating": "Valutazione",
        "streamUrl": "URL Stream",
        "epgSource": "Fonte EPG",
        "genre": "Genere",
        "episodeNumber": "N. Episodio",
        "description": "Descrizione",
        "duration": "Durata",
        "publishedDate": "Pubblicato",
        "episodes": "Episodi",
        "order": "Ordine",
        "name": "Nome",
        "slug": "Slug",
        "subtitles": "Sottotitoli"
      },
      "validation": {
        "titleRequired": "Il titolo è obbligatorio",
        "nameRequired": "Il nome è obbligatorio",
        "streamUrlRequired": "L'URL dello stream è obbligatorio",
        "audioUrlRequired": "L'URL audio è obbligatorio"
      },
      "episodes_one": "episodio",
      "episodes_other": "episodi",
      "noEpisodes": "Nessun episodio trovato",
      "type": {
        "series": "Serie",
        "movie": "Film"
      },
      "toggleCarousel": "Attiva/disattiva carousel",
      "editor": {
        "pageTitle": "Modifica Contenuto",
        "pageTitleNew": "Aggiungi Contenuto",
        "sections": {
          "basicInfo": "Informazioni Base",
          "media": "Media",
          "streaming": "Streaming",
          "details": "Dettagli Contenuto",
          "publishing": "Pubblicazione",
          "accessControl": "Controllo Accesso",
          "podcastDetails": "Dettagli Podcast",
          "episodeDetails": "Dettagli Episodio",
          "stationDetails": "Dettagli Stazione",
          "channelDetails": "Dettagli Canale"
        },
        "fields": {
          "title": "Titolo",
          "titlePlaceholder": "Titolo contenuto",
          "titleRequired": "Il titolo è obbligatorio",
          "year": "Anno",
          "yearPlaceholder": "2024",
          "description": "Descrizione",
          "descriptionPlaceholder": "Descrizione contenuto",
          "thumbnail": "Miniatura (rapporto 3:4)",
          "thumbnailUrl": "URL Miniatura",
          "thumbnailUrlPlaceholder": "https://example.com/thumbnail.jpg",
          "backdrop": "Sfondo (rapporto 16:9)",
          "backdropUrl": "URL Sfondo",
          "posterCover": "Copertina Podcast",
          "logo": "Logo",
          "channelLogo": "Logo Canale",
          "stationLogo": "Logo Stazione",
          "streamUrl": "URL Stream",
          "streamUrlRequired": "L'URL dello stream è obbligatorio",
          "streamType": "Tipo Stream",
          "drmProtected": "Protetto da DRM",
          "drmProtectedLabel": "Questo contenuto richiede protezione DRM",
          "category": "Categoria",
          "categoryRequired": "La categoria è obbligatoria",
          "duration": "Durata",
          "durationPlaceholder": "1:30:00",
          "rating": "Valutazione",
          "ratingPlaceholder": "PG-13",
          "genre": "Genere",
          "genrePlaceholder": "Drammatico",
          "director": "Regista",
          "directorPlaceholder": "Nome regista",
          "isSeries": "Serie",
          "isSeriesLabel": "Questo è un contenuto seriale/multiparte",
          "season": "Stagione",
          "episode": "Episodio",
          "seriesId": "ID Serie",
          "seriesIdPlaceholder": "identificatore-serie",
          "isPublished": "Pubblica",
          "isPublishedLabel": "Pubblica questo contenuto immediatamente",
          "isFeatured": "In Evidenza",
          "isFeaturedLabel": "Metti in evidenza questo contenuto sulla homepage",
          "requiresSubscription": "Abbonamento Richiesto",
          "isKidsContent": "Contenuto per Bambini",
          "isKidsContentLabel": "Questo è un contenuto adatto ai bambini",
          "author": "Autore",
          "authorPlaceholder": "Autore podcast",
          "podcastCategory": "Categoria",
          "podcastCategoryPlaceholder": "Notizie, Scienza, ecc.",
          "rssFeed": "URL Feed RSS",
          "rssFeedPlaceholder": "https://example.com/feed.xml",
          "website": "URL Sito Web",
          "websitePlaceholder": "https://example.com",
          "episodeNumber": "N. Episodio",
          "seasonNumber": "N. Stagione",
          "audioUrl": "URL Audio",
          "audioUrlRequired": "L'URL audio è obbligatorio",
          "audioUrlPlaceholder": "https://example.com/episode.mp3",
          "publishedAt": "Data Pubblicazione",
          "epgSource": "URL Fonte EPG",
          "epgSourcePlaceholder": "https://example.com/epg.xml",
          "currentShow": "Programma Corrente",
          "currentShowPlaceholder": "Nome programma",
          "nextShow": "Prossimo Programma",
          "nextShowPlaceholder": "Nome programma",
          "currentSong": "Canzone Corrente",
          "currentSongPlaceholder": "Titolo canzone",
          "isActive": "Attivo",
          "isActiveLabel": "Il canale è attivo",
          "requiredSubscription": "Abbonamento Richiesto",
          "publishedDate": "Data Pubblicazione"
        },
        "subscriptionTiers": {
          "basic": "Base",
          "premium": "Premium",
          "family": "Famiglia"
        },
        "actions": {
          "save": "Salva",
          "saving": "Salvataggio...",
          "cancel": "Annulla"
        },
        "imageUpload": {
          "dropHere": "Rilascia l'immagine qui o clicca per caricare",
          "formats": "PNG, JPG, WebP fino a {{maxSize}}MB",
          "uploading": "Caricamento...",
          "success": "Immagine caricata con successo",
          "orPasteUrl": "Oppure incolla URL immagine",
          "urlPlaceholder": "https://example.com/image.jpg",
          "validateButton": "Aggiungi",
          "validating": "Validazione...",
          "clear": "Rimuovi immagine",
          "errors": {
            "imageOnly": "Seleziona un file immagine",
            "tooLarge": "La dimensione del file deve essere inferiore a {{maxSize}}MB",
            "uploadFailed": "Caricamento fallito",
            "invalidUrl": "URL non valido"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "Seleziona categoria...",
        "searchPlaceholder": "Cerca categorie...",
        "loading": "Caricamento categorie...",
        "noResults": "Nessuna categoria trovata",
        "noCategories": "Nessuna categoria disponibile",
        "createNew": "Crea nuova categoria",
        "errors": {
          "loadFailed": "Impossibile caricare le categorie",
          "createFailed": "Impossibile creare la categoria"
        },
        "modal": {
          "title": "Crea Nuova Categoria",
          "placeholder": "Nome categoria (es. Film, Serie)",
          "creating": "Creazione...",
          "create": "Crea"
        }
      },
      "streamUrlInput": {
        "copyUrl": "Copia URL",
        "copied": "URL copiato negli appunti",
        "streamType": "Tipo Stream",
        "validUrl": "URL valido - rilevato come {{type}}",
        "errors": {
          "required": "L'URL dello stream è obbligatorio",
          "invalidFormat": "Formato URL non valido"
        },
        "supportedFormats": {
          "title": "Formati supportati:",
          "hls": "HLS: stream .m3u8",
          "dash": "DASH: stream .mpd",
          "audio": "Audio: .mp3, .aac o stream audio"
        }
      }
    },
    "categories": {
      "subtitle": "Gestisci le categorie di contenuti",
      "emptyMessage": "Nessuna categoria trovata",
      "status": {
        "active": "Attiva",
        "inactive": "Inattiva"
      },
      "form": {
        "nameHebrew": "Nome categoria (Ebraico)",
        "nameEnglish": "Nome categoria (Inglese)",
        "slug": "Slug"
      }
    },
    "liveChannels": {
      "subtitle": "Gestisci i canali TV live",
      "emptyMessage": "Nessun canale live trovato",
      "subtitleSettings": "Impostazioni Sottotitoli Live",
      "form": {
        "name": "Nome canale",
        "streamUrl": "URL Stream",
        "epgSource": "URL Fonte EPG (opzionale)",
        "currentShow": "Programma Corrente",
        "order": "Ordine",
        "supportsSubtitles": "Abilita Sottotitoli Live",
        "primaryLanguage": "Lingua Principale (Sorgente)",
        "targetLanguages": "Lingue Traduzione Disponibili",
        "targetLanguagesHelp": "Seleziona in quali lingue gli utenti possono tradurre in tempo reale"
      }
    },
    "radioStations": {
      "subtitle": "Gestisci le stazioni radio",
      "emptyMessage": "Nessuna stazione radio trovata",
      "form": {
        "name": "Nome stazione",
        "genre": "Genere",
        "streamUrl": "URL Stream",
        "currentShow": "Programma Corrente (opzionale)",
        "currentSong": "Canzone Corrente (opzionale)",
        "order": "Ordine"
      }
    },
    "podcasts": {
      "subtitle": "Gestisci podcast ed episodi",
      "episodesSubtitle": "Gestisci episodi",
      "emptyMessage": "Nessun podcast trovato",
      "noEpisodes": "Nessun episodio trovato",
      "form": {
        "title": "Titolo podcast",
        "author": "Autore",
        "description": "Descrizione",
        "category": "Categoria",
        "rssFeed": "URL Feed RSS",
        "website": "URL Sito Web (opzionale)"
      },
      "episodes": {
        "form": {
          "title": "Titolo episodio",
          "description": "Descrizione",
          "episodeNumber": "Numero episodio",
          "seasonNumber": "Numero stagione (opzionale)",
          "duration": "Durata",
          "audioUrl": "URL Audio (obbligatorio)",
          "publishedDate": "Data Pubblicazione (AAAA-MM-GG)"
        }
      }
    },
    "users": {
      "subtitle": "Gestisci utenti e account",
      "addUser": "Aggiungi Utente",
      "status": {
        "active": "Attivo",
        "inactive": "Inattivo",
        "blocked": "Bloccato"
      },
      "filters": {
        "all": "Tutto",
        "active": "Attivi",
        "inactive": "Inattivi",
        "blocked": "Bloccati"
      },
      "columns": {
        "name": "Nome",
        "role": "Ruolo",
        "subscription": "Abbonamento",
        "noSubscription": "Nessun Abbonamento",
        "status": "Stato",
        "created": "Creato",
        "actions": "Azioni"
      },
      "confirmDelete": "Elimina Utente",
      "confirmDeleteMessage": "Sei sicuro di voler eliminare {{name}}? Questa azione non può essere annullata.",
      "resetPassword": "Reimposta Password",
      "block": "Blocca",
      "unban": "Sblocca",
      "confirmResetPassword": "Inviare email di reimpostazione password a {{email}}?",
      "resetPasswordSent": "Email di reimpostazione password inviata",
      "recentActivity": "Attività Recente",
      "noActivity": "Nessuna attività",
      "notFound": "Utente non trovato",
      "backToList": "Torna alla lista",
      "banReason": "Motivo blocco",
      "banReasonPrompt": "Motivo del blocco:",
      "confirmUnban": "Sbloccare l'utente?",
      "userDetails": "Dettagli Utente",
      "id": "ID",
      "registered": "Registrato",
      "billingHistory": "Storico Fatturazione",
      "noPayments": "Nessun pagamento"
    },
    "campaigns": {
      "subtitle": "Gestisci codici coupon e sconti",
      "expired": "Scaduta",
      "status": {
        "active": "Attiva",
        "inactive": "Inattiva"
      },
      "columns": {
        "name": "Nome",
        "discount": "Sconto",
        "usage": "Utilizzi",
        "validUntil": "Valido Fino Al",
        "status": "Stato",
        "actions": "Azioni"
      },
      "confirmDelete": "Elimina Campagna",
      "confirmDeleteMessage": "Sei sicuro di voler eliminare \"{{name}}\"? Questa azione non può essere annullata.",
      "searchPlaceholder": "Cerca campagne...",
      "emptyMessage": "Nessuna campagna trovata",
      "deactivate": "Disattiva",
      "activate": "Attiva",
      "createTitle": "Nuova Campagna",
      "editTitle": "Modifica Campagna",
      "formSubtitle": "Configura un codice coupon o sconto",
      "form": {
        "name": "Nome Campagna",
        "namePlaceholder": "es. Saldi Estate 2024",
        "code": "Codice Coupon",
        "generate": "Genera",
        "discountType": "Tipo Sconto",
        "discountValue": "Valore Sconto",
        "maxUses": "Utilizzi Massimi",
        "unlimited": "Illimitati",
        "validUntil": "Valido Fino Al",
        "active": "Campagna Attiva"
      }
    },
    "subscriptions": {
      "subtitle": "Visualizza e gestisci gli abbonati del sistema",
      "status": {
        "active": "Attivo",
        "paused": "In Pausa",
        "cancelled": "Cancellato",
        "expired": "Scaduto"
      },
      "columns": {
        "user": "Utente",
        "plan": "Piano",
        "price": "Prezzo",
        "nextBilling": "Prossima Fatturazione",
        "status": "Stato"
      },
      "perMonth": "/mese",
      "searchPlaceholder": "Cerca abbonamento...",
      "emptyMessage": "Nessun abbonamento trovato",
      "actions": {
        "changePlan": "Cambia Piano",
        "pause": "Pausa",
        "resume": "Riprendi",
        "cancel": "Annulla",
        "delete": "Elimina"
      },
      "editPlan": {
        "title": "Cambia Piano Abbonamento",
        "user": "Utente",
        "currentPlan": "Piano Corrente",
        "newPlan": "Seleziona Nuovo Piano"
      },
      "addSubscription": {
        "title": "Aggiungi Abbonamento",
        "userEmail": "Email Utente",
        "emailPlaceholder": "Inserisci email utente",
        "duration": "Durata (giorni)",
        "selectPlan": "Seleziona Piano"
      },
      "fillAllFields": "Compila tutti i campi",
      "userNotFound": "Utente non trovato",
      "selectOneToEdit": "Seleziona esattamente un abbonamento da modificare",
      "selectToDelete": "Seleziona abbonamenti da eliminare",
      "confirmDeleteMultiple": "Eliminare {{count}} abbonamenti?",
      "selected": "selezionati",
      "confirmDelete": "Sei sicuro di voler eliminare l'abbonamento per {{user}}? Questa azione non può essere annullata."
    },
    "marketingDashboard": {
      "subtitle": "Panoramica Marketing",
      "refresh": "Aggiorna",
      "totalSubscribers": "Abbonati Totali",
      "emailOpenRate": "Tasso Apertura Email",
      "pushClickRate": "Tasso Click Push",
      "activeSegments": "Segmenti Attivi",
      "campaignStatus": {
        "active": "Attiva",
        "completed": "Completata",
        "scheduled": "Programmata",
        "draft": "Bozza"
      }
    },
    "transactions": {
      "subtitle": "Visualizza storico pagamenti",
      "exportCsv": "Esporta CSV",
      "status": {
        "completed": "Completato",
        "pending": "In Attesa",
        "failed": "Fallito",
        "refunded": "Rimborsato"
      },
      "columns": {
        "id": "ID",
        "user": "Utente",
        "amount": "Importo",
        "type": "Tipo",
        "status": "Stato",
        "date": "Data"
      },
      "filters": {
        "all": "Tutto"
      },
      "searchPlaceholder": "Cerca transazione...",
      "emptyMessage": "Nessuna transazione trovata",
      "details": "Dettagli Transazione",
      "email": "E-mail"
    },
    "pushNotifications": {
      "subtitle": "Crea e invia notifiche agli utenti",
      "newNotification": "Nuova Notifica",
      "status": {
        "draft": "Bozza",
        "sent": "Inviata",
        "scheduled": "Programmata"
      },
      "columns": {
        "title": "Titolo",
        "status": "Stato",
        "sent": "Inviate",
        "opened": "Aperte",
        "scheduledAt": "Programmata Per",
        "created": "Creata",
        "actions": "Azioni"
      },
      "filters": {
        "all": "Tutto"
      },
      "searchPlaceholder": "Cerca notifica...",
      "emptyMessage": "Nessuna notifica trovata",
      "createModal": "Nuova Notifica Push",
      "editModal": "Modifica Notifica",
      "scheduleModal": "Programma Notifica",
      "titleLabel": "Titolo",
      "bodyLabel": "Corpo",
      "dateTimeLabel": "Data e Ora",
      "cancel": "Annulla",
      "create": "Crea Notifica",
      "schedule": "Programma",
      "send": "Invia Ora",
      "confirmSend": "Inviare la notifica \"{{title}}\"?",
      "confirmDelete": "Eliminare la notifica \"{{title}}\"?",
      "fillRequired": "Compila titolo e corpo"
    }
  },
  "placeholder": {
    "email": "[it] your@email.com",
    "password": "[it] ••••••••",
    "pin": "[it] ••••",
    "dateRange": {
      "from": "[it] From (YYYY-MM-DD)",
      "to": "[it] To (YYYY-MM-DD)"
    },
    "amount": {
      "min": "[it] Min",
      "max": "[it] Max",
      "price": "[it] 0.00"
    },
    "chatMessage": "[it] Type here...",
    "deepLink": "[it] bayitplus://content/123",
    "scheduleDateTime": "[it] YYYY-MM-DDTHH:mm",
    "roomCode": "[it] ABCD1234",
    "time": {
      "start": "[it] 08:00",
      "end": "[it] 10:00"
    },
    "filter": {
      "userId": "[it] Enter user ID"
    },
    "datetime": "[it] YYYY-MM-DDTHH:mm",
    "number": "[it] 0",
    "chat": "[it] Type your message..."
  },
  "components": {
    "select": {
      "default": "[it] Select..."
    }
  },
  "plans": {
    "basic": {
      "name": "Base",
      "features": [
        "Tutti i contenuti VOD",
        "Radio e Podcast",
        "Guarda su 1 dispositivo",
        "Qualità SD"
      ],
      "notIncluded": [
        "Canali in diretta",
        "Assistente AI",
        "Visione offline"
      ]
    },
    "premium": {
      "name": "Premium",
      "features": [
        "Tutti i contenuti VOD",
        "Canali in diretta",
        "Radio e Podcast",
        "Assistente AI intelligente",
        "Guarda su 2 dispositivi",
        "Qualità HD"
      ],
      "notIncluded": [
        "Visione offline",
        "Profili familiari"
      ]
    },
    "family": {
      "name": "Famiglia",
      "features": [
        "Tutti i contenuti VOD",
        "Canali in diretta",
        "Radio e Podcast",
        "Assistente AI intelligente",
        "Guarda su 4 dispositivi",
        "Qualità 4K",
        "5 profili familiari",
        "Download offline"
      ],
      "notIncluded": []
    },
    "batchActions": {
      "selectedCount": "[it] {{count}} selected",
      "selectedCount_one": "[it] {{count}} selected",
      "selectedCount_other": "[it] {{count}} selected",
      "clear": "[it] Clear"
    },
    "costDashboard": {
      "title": "[it] Cost Dashboard",
      "costBreakdown": "[it] Cost Breakdown",
      "loadingBreakdown": "[it] Loading breakdown...",
      "aiCosts": "[it] AI Costs",
      "infrastructure": "[it] Infrastructure",
      "thirdParty": "[it] Third-party",
      "thirdPartyApis": "[it] Third-party APIs",
      "translation": "[it] Translation",
      "search": "[it] Search",
      "percentOfTotal": "[it] % of total",
      "components": "[it] Components",
      "topSpenders": {
        "title": "[it] Top 20 Spenders (Monthly)",
        "loading": "[it] Loading top spenders...",
        "rank": "[it] Rank",
        "userId": "[it] User ID",
        "costRange": "[it] Cost Range",
        "privacyNote": "[it] User IDs are hashed and costs are aggregated into ranges for privacy protection."
      },
      "categories": {
        "permanent": "[it] Permanent",
        "transient": "[it] Transient",
        "permanentVsTransient": "[it] Permanent vs Transient",
        "permanentFixed": "[it] Permanent (Fixed)",
        "transientVariable": "[it] Transient (Variable)",
        "permanentDesc": "[it] Infrastructure costs that occur monthly regardless of usage",
        "transientDesc": "[it] Usage-based costs that fluctuate with platform activity",
        "detailedBreakdown": "[it] Detailed Breakdown",
        "costItem": "[it] Cost Item",
        "category": "[it] Category",
        "amount": "[it] Amount"
      },
      "timeline": {
        "title": "[it] Cost Timeline",
        "loading": "[it] Loading timeline...",
        "amountLabel": "[it] Amount ($)",
        "revenue": "[it] Revenue",
        "totalCost": "[it] Total Cost",
        "netProfit": "[it] Net Profit",
        "showingData": "[it] Showing data from {{start}} to {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "[it] Net Profit/Loss",
        "margin": "[it] margin",
        "revenue": "[it] REVENUE",
        "totalCosts": "[it] TOTAL COSTS"
      }
    }
  },
  "subscribe": {
    "title": "Scegli il tuo piano",
    "subtitle": "7 giorni di prova gratuita per qualsiasi piano. Annulla quando vuoi.",
    "monthly": "Mensile",
    "yearly": "Annuale",
    "save2Months": "Risparmia 2 mesi",
    "popular": "Più popolare",
    "period": "/mese",
    "perYear": "/anno",
    "select": "Seleziona piano",
    "selected": "Selezionato",
    "processing": "Elaborazione...",
    "startTrial": "Inizia prova gratuita",
    "noCharge": "La tua carta non verrà addebitata durante il periodo di prova"
  },
  "notFound": {
    "title": "[it] Page Not Found",
    "description": "[it] The page you're looking for doesn't exist or has been moved.",
    "homeButton": "[it] Go Home",
    "searchButton": "[it] Search",
    "orTry": "[it] Or try:",
    "liveChannel": "[it] Live",
    "vodLabel": "[it] Movies",
    "podcastsLabel": "[it] Podcasts"
  },
  "profiles": {
    "addProfile": "[it] Add Profile",
    "enterPin": "[it] Enter PIN",
    "selectError": "[it] Error selecting profile",
    "wrongPin": "[it] Incorrect PIN",
    "loading": "[it] Loading profiles...",
    "manage": "[it] Manage Profiles",
    "whoIsWatching": "[it] Who's Watching?",
    "manageProfiles": "[it] Manage Profiles",
    "kids": "Bambini",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "[it] Content not found",
    "backToHome": "[it] Back to Home",
    "episodes": "[it] Episodes",
    "addToList": "[it] Add to List",
    "like": "[it] Like",
    "share": "[it] Share",
    "cast": "[it] Cast",
    "episodesList": "[it] Episodes",
    "schedule": "[it] Schedule",
    "now": "[it] Now",
    "related": "[it] Related Content",
    "deleteEpisode": "[it] Delete Episode",
    "confirmDeleteEpisode": "[it] Delete this episode?"
  },
  "live": {
    "title": "[it] Live TV",
    "next": "[it] Next:",
    "noChannels": "[it] No channels available",
    "tryLater": "[it] Try again later",
    "categories": {
      "all": "[it] All",
      "news": "[it] News",
      "entertainment": "[it] Entertainment",
      "sports": "[it] Sports",
      "kids": "[it] Kids",
      "music": "[it] Music"
    }
  },
  "judaism": {
    "title": "Ebraismo",
    "items": "elementi",
    "empty": "Nessun contenuto disponibile",
    "emptyHint": "Prova a selezionare un'altra categoria",
    "dashboard": "La tua dashboard ebraica",
    "categories": {
      "news": "Notizie ebraiche",
      "community": "Comunità"
    },
    "shabbat": {
      "title": "Orari Shabbat",
      "shabbatShalom": "Shabbat Shalom!",
      "shabbatMode": "Modalità Shabbat",
      "endsIn": "Lo Shabbat termina tra",
      "candleLighting": "Accensione candele",
      "havdalah": "Havdalah",
      "parashat": "Parashat",
      "friday": "Venerdì",
      "saturday": "Sabato",
      "noData": "Impossibile caricare gli orari dello Shabbat"
    },
    "erevShabbat": {
      "title": "[it] Erev Shabbat",
      "prepareFor": "[it] Prepare for Shabbat",
      "inTime": "[it] in {{time}}",
      "featuredContent": "[it] Shabbat Content",
      "noContent": "[it] Shabbat content coming soon!",
      "shabbatShalom": "[it] Shabbat Shalom!",
      "timeUntil": "[it] Time until Shabbat",
      "shabbatSongs": "[it] Shabbat Songs",
      "parashaStudy": "[it] Parasha",
      "shabbatRecipes": "[it] Recipes",
      "prayers": "[it] Prayers"
    }
  },
  "children": {
    "title": "Bambini",
    "items": "elementi",
    "empty": "Nessun contenuto disponibile",
    "emptyHint": "Prova un'altra categoria",
    "exitKidsMode": "Esci dalla modalità bambini",
    "exitDescription": "Inserisci il codice genitore per uscire",
    "parentCode": "Codice genitore",
    "confirm": "Conferma",
    "wrongCode": "Codice errato",
    "noContent": "[it] No content available",
    "tryAnotherCategory": "[it] Try selecting another category",
    "categories": {
      "all": "Tutto",
      "cartoons": "Cartoni animati",
      "educational": "Educativo",
      "music": "Musica",
      "hebrew": "Ebraico",
      "stories": "Storie",
      "jewish": "Ebraico"
    },
    "ageRatings": {
      "3": "[it] Ages 3+",
      "5": "[it] Ages 5+",
      "7": "[it] Ages 7+",
      "10": "[it] Ages 10+",
      "12": "[it] Ages 12+"
    },
    "moderation": {
      "pending": "[it] Pending Review",
      "approved": "[it] Approved",
      "rejected": "[it] Rejected"
    },
    "admin": {
      "stats": "[it] Kids Content Manager",
      "seedContent": "[it] Seed Content",
      "importArchive": "[it] Import Archive.org",
      "syncPodcasts": "[it] Sync Podcasts",
      "syncYouTube": "[it] Sync YouTube",
      "tagVod": "[it] Tag VOD",
      "pendingModeration": "[it] Pending Moderation"
    }
  },
  "youngsters": {
    "title": "[it] Youngsters",
    "items": "[it] items",
    "empty": "[it] No content available",
    "emptyHint": "[it] Try another category",
    "exitYoungstersMode": "[it] Exit Youngsters Mode",
    "exitDescription": "[it] Enter parent code to exit",
    "parentCode": "[it] Parent code",
    "confirm": "[it] Confirm",
    "wrongCode": "[it] Incorrect code",
    "noContent": "[it] No content available",
    "tryAnotherCategory": "[it] Try selecting another category",
    "categories": {
      "all": "[it] All",
      "trending": "[it] Trending",
      "news": "[it] News",
      "culture": "[it] Culture",
      "educational": "[it] Educational",
      "music": "[it] Music",
      "entertainment": "[it] Entertainment",
      "sports": "[it] Sports",
      "tech": "[it] Technology",
      "judaism": "[it] Judaism"
    },
    "ageGroups": {
      "middle-school": "[it] Middle School (12-14)",
      "high-school": "[it] High School (15-17)"
    },
    "moderation": {
      "pending": "[it] Pending Review",
      "approved": "[it] Approved",
      "rejected": "[it] Rejected"
    },
    "admin": {
      "stats": "[it] Youngsters Content Manager",
      "seedContent": "[it] Seed Content",
      "importArchive": "[it] Import Archive.org",
      "syncPodcasts": "[it] Sync Podcasts",
      "syncYouTube": "[it] Sync YouTube",
      "tagVod": "[it] Tag VOD",
      "pendingModeration": "[it] Pending Moderation"
    }
  },
  "chatbot": {
    "title": "Assistente Bayit+",
    "greeting": "Ciao! Sono l'assistente intelligente Bayit+. Come posso aiutarti oggi? Clicca sul microfono e parla, o digita un messaggio.",
    "openChat": "Apri chat",
    "welcome": "Ciao! Sono l'assistente intelligente Bayit+. Come posso aiutarti oggi? Clicca sul microfono e parla, o digita un messaggio.",
    "placeholder": "Digita qui...",
    "recording": "Registrazione... clicca di nuovo per fermare",
    "transcribing": "Trascrizione...",
    "stopRecording": "Ferma registrazione",
    "startRecording": "Avvia registrazione vocale",
    "recommendations": "Ecco alcuni consigli:",
    "showMultipleSuccess": "[it] Showing {{count}} content items in widgets",
    "showMultipleNotFound": "[it] Could not find the requested content. Please try different names.",
    "resolvingContent": "[it] Finding your content...",
    "errors": {
      "micPermission": "Impossibile accedere al microfono. Verifica i permessi del microfono nel browser.",
      "transcribeFailed": "Impossibile trascrivere la registrazione. Riprova.",
      "general": "Spiacente, si è verificato un problema. Riprova."
    },
    "suggestions": {
      "whatToWatch": "Cosa guardare oggi?",
      "israeliMovies": "Film israeliani consigliati",
      "whatsOnNow": "Cosa c'è in onda ora?",
      "popularPodcasts": "Podcast popolari"
    },
    "voiceCommands": {
      "showChannels": "[it] Show me channels...",
      "playChess": "[it] Start a chess game with...",
      "multiContent": "[it] Show side by side..."
    }
  },
  "chat": {
    "title": "[it] Bayit+ Assistant",
    "greeting": "[it] Hello! I'm Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message."
  },
  "subtitles": {
    "nikud": "Nikud",
    "selection": "Selezione",
    "translation": "Traduzione",
    "translating": "Traduzione in corso...",
    "close": "Chiudi",
    "unavailable": "Traduzione non disponibile",
    "off": "Disattivati",
    "none": "Nessuno",
    "autoGenerated": "Generati automaticamente",
    "selectLanguage": "Seleziona Lingua Sottotitoli",
    "liveTranslate": "Traduzione in Tempo Reale",
    "translateTo": "Traduci In",
    "downloadMore": "Scarica altri sottotitoli...",
    "downloading": "Ricerca su OpenSubtitles...",
    "opensubtitlesSource": "Da OpenSubtitles.com",
    "downloadSuccess": "Scaricato/i {{count}} sottotitolo/i",
    "noSubtitlesFound": "Nessun sottotitolo trovato per questo contenuto",
    "smartSubs": "Sottotitoli intelligenti",
    "smartSubsDescription": "Vista duale: Ebraico semplificato + Inglese con evidenziazione delle radici",
    "smartSubsDualView": "Vista Duale",
    "shoreshToggle": "Evidenziazione Radici",
    "shoreshOn": "Evidenziazione Shoresh attivata",
    "shoreshOff": "Evidenziazione Shoresh disattivata",
    "nikudLive": "Ebraico con Nikud",
    "nikudLiveDescription": "Sottotitoli ebraici vocalizzati con segni diacritici per una lettura più facile",
    "nikudEnabled": "Sottotitoli Nikud attivati",
    "nikudDisabled": "Sottotitoli Nikud disattivati",
    "nikudSubtitleLabel": "Ebraico con nikud: {{text}}",
    "available": "Sottotitoli",
    "clickToEnable": "Clicca per attivare la traduzione in tempo reale",
    "connectionError": "Errore Traduzione in Tempo Reale",
    "inputLanguageTooltip": "Verifica Lingua di Input",
    "premiumRequired": "Richiesto abbonamento Premium",
    "selectInputLanguage": "Seleziona lingua di input",
    "translateActive": "Traduzione in Tempo Reale Attiva",
    "noEnglishSubtitles": "Nessun sottotitolo inglese disponibile per questo contenuto.",
    "hebrewMode": {
      "title": "Modalità Visualizzazione Ebraico",
      "unavailable": "Non disponibile",
      "generate": "Genera",
      "regular": {
        "title": "Ebraico Standard",
        "description": "Testo ebraico standard senza segni vocalici"
      },
      "nikud": {
        "title": "Ebraico con Nikud",
        "description": "Ebraico vocalizzato con segni vocalici per una lettura più facile",
        "unavailableReason": "Elaborazione IA non disponibile per questo contenuto"
      },
      "shoresh": {
        "title": "Shoresh (Radici)",
        "description": "Parole ebraiche con analisi delle radici: parola [radice]",
        "unavailableReason": "Analisi delle radici non disponibile per questo contenuto"
      }
    },
    "englishMode": {
      "title": "Modalità Visualizzazione Inglese",
      "unavailable": "Non disponibile",
      "generate": "Genera",
      "firstTimeHint": "Queste modalità basate su IA aiutano a mantenere l'ebraico mentre si impara la struttura delle frasi inglesi. Ogni modalità offre un'esperienza di apprendimento unica.",
      "regular": {
        "title": "Inglese Standard",
        "description": "Sottotitoli inglesi standard"
      },
      "heblish": {
        "title": "Heblish",
        "description": "Inglese con inserimenti di parole ebraiche per un apprendimento immersivo",
        "unavailableReason": "Elaborazione Heblish non disponibile per questo contenuto"
      },
      "grammarFlip": {
        "title": "Grammar-Flip",
        "description": "Parole ebraiche con struttura frase inglese (Soggetto-Verbo-Oggetto)",
        "unavailableReason": "Elaborazione Grammar-Flip non disponibile per questo contenuto"
      },
      "slangSynthesis": {
        "title": "Sintesi gergale",
        "description": "Mix di slang israeliano moderno e americano per contenuti coinvolgenti",
        "unavailableReason": "Elaborazione Slang Synthesis non disponibile per questo contenuto"
      }
    },
    "loading": "Caricamento sottotitoli...",
    "error": {
      "title": "Errore Sottotitoli",
      "retry": "Riprova",
      "loadFailed": "Impossibile caricare i sottotitoli",
      "cuesFailed": "Impossibile caricare il testo dei sottotitoli",
      "networkError": "Errore di rete - verifica la tua connessione",
      "serverError": "Errore del server - riprova più tardi"
    },
    "aiModesAvailable": "Modalità IA disponibili",
    "aiModesTitle": "Modalità sottotitoli IA",
    "fetchSubtitles": "Recupera sottotitoli",
    "fontSize": "Dimensione carattere",
    "mode": {
      "engrew": "Engrew",
      "heblish": "Heblish",
      "shoresh": "Shoresh",
      "standard": "Standard"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "Cerca sottotitoli esterni",
    "settingsTitle": "Impostazioni sottotitoli",
    "showBackground": "Mostra sfondo",
    "singleMode": "Modalità singola",
    "splitMode": "Modalità divisa",
    "primary_language": "Lingua Principale",
    "secondary_language": "Lingua Secondaria",
    "layout_mode": "Modalità layout",
    "interactive_title": "Sottotitoli Interattivi"
  },
  "video": {
    "watchTrailer": "[it] Watch Trailer",
    "closeTrailer": "[it] Close Trailer",
    "deleteConfirm": "[it] Delete this episode?"
  },
  "recordings": {
    "title": "[it] My Recordings",
    "subtitle": "[it] View and manage your recorded live streams",
    "record": "[it] Record",
    "recording": "[it] Recording",
    "storageUsed": "[it] Storage Used",
    "totalRecordings": "[it] Total Recordings",
    "maxDuration": "[it] Max Duration",
    "noRecordings": "[it] No Recordings Yet",
    "noRecordingsHint": "[it] Start recording from any live channel!",
    "confirmDelete": "[it] Are you sure you want to delete this recording? This action cannot be undone.",
    "deleteRecording": "[it] Delete Recording",
    "deleteFailed": "[it] Failed to delete recording",
    "expires": "[it] Expires",
    "subtitlesAvailable": "[it] Subtitles Available",
    "recordingSaved": "[it] Recording Saved!",
    "savedSuccess": "[it] Recording saved successfully! Duration: {{duration}}",
    "viewInMyRecordings": "[it] View in My Recordings",
    "error": "[it] Recording Error",
    "startFailed": "[it] Failed to start recording. Please try again.",
    "stopFailed": "[it] Failed to stop recording. Please try again.",
    "page": "[it] Page"
  },
  "chess": {
    "title": "[it] Chess",
    "welcome": "[it] Welcome to Chess",
    "subtitle": "[it] Play chess with friends and family around the world",
    "createGame": "[it] Create New Game",
    "joinGame": "[it] Join Game",
    "gameCode": "[it] Game Code",
    "enterGameCode": "[it] Enter Game Code",
    "invalidGameCode": "[it] Invalid game code. Must be 6 characters.",
    "joinFailed": "[it] Failed to join game",
    "join": "[it] Join",
    "create": "[it] Create",
    "chooseColor": "[it] Choose Your Color",
    "white": "[it] White",
    "black": "[it] Black",
    "chatPlaceholder": "[it] Type a message... (@bot for advice)",
    "botHint": "[it] Tag @bot in your message to get chess advice from our AI assistant",
    "bot": "[it] Chess Assistant",
    "mute": "[it] Mute",
    "unmute": "[it] Unmute",
    "speaking": "[it] participants",
    "resign": "[it] Resign",
    "offerDraw": "[it] Offer Draw",
    "newGame": "[it] New Game",
    "checkmate": "[it] Checkmate!",
    "stalemate": "[it] Stalemate",
    "draw": "[it] Draw",
    "resigned": "[it] Game Resigned",
    "reconnecting": "[it] Reconnecting...",
    "moveHistory": "[it] Move History",
    "noMoves": "[it] No moves yet",
    "showHints": "[it] Show Guide Hints",
    "yourTurn": "[it] Your Turn",
    "opponentTurn": "[it] Opponent's Turn",
    "waitingForOpponent": "[it] Waiting for opponent...",
    "gameOver": "[it] Game Over",
    "sendingInvite": "[it] Sending game invite to {{name}}...",
    "inviteSent": "[it] Game invite sent to {{name}}! Game code: {{code}}",
    "inviteFailed": "[it] Could not find that user. Please check the name and try again.",
    "inviteReceived": "[it] {{name}} invited you to a chess game!",
    "joinInvite": "[it] Join Game",
    "challenge": "[it] Challenge",
    "playedAsWhite": "[it] Played as White",
    "playedAsBlack": "[it] Played as Black",
    "gameMode": "[it] Game Mode",
    "playVsFriend": "[it] Play vs Friend",
    "playVsBot": "[it] Play vs Bot",
    "difficulty": "[it] Difficulty",
    "easy": "[it] Easy",
    "medium": "[it] Medium",
    "hard": "[it] Hard",
    "chessBot": "[it] Chess Bot",
    "chat": {
      "title": "[it] Chat",
      "inputPlaceholder": "[it] Type a message..."
    },
    "acceptDraw": "[it] Accept Draw",
    "acceptInvite": "[it] Accept Invite",
    "blackCaptured": "[it] Black Captured",
    "blackTurn": "[it] Black's Turn",
    "challengeFriend": "[it] Challenge Friend",
    "challengeViaWhatsApp": "[it] Challenge via WhatsApp",
    "copyCode": "[it] Copy Code",
    "declineDraw": "[it] Decline Draw",
    "declineInvite": "[it] Decline Invite",
    "drawOffered": "[it] Draw Offered",
    "joinByGameCode": "[it] Join by Game Code",
    "noFriendsYet": "[it] No friends yet",
    "offline": "[it] Offline",
    "online": "[it] Online",
    "opponent": "[it] Opponent",
    "whiteCaptured": "[it] White Captured",
    "whiteTurn": "[it] White's Turn",
    "you": "[it] You"
  },
  "friends": {
    "title": "[it] Friends & Opponents",
    "subtitle": "[it] Connect with players and challenge friends",
    "myFriends": "[it] My Friends",
    "requests": "[it] Requests",
    "findPlayers": "[it] Find Players",
    "friendsLabel": "[it] Friends",
    "pendingLabel": "[it] Pending",
    "add": "[it] Add Friend",
    "remove": "[it] Remove",
    "accept": "[it] Accept",
    "reject": "[it] Reject",
    "cancel": "[it] Cancel",
    "noFriends": "[it] No friends yet",
    "noFriendsDesc": "[it] Search for players and send friend requests",
    "lastGame": "[it] Last game: {{time}}",
    "friendsSince": "[it] Friends since {{date}}",
    "incomingRequests": "[it] Incoming Requests",
    "outgoingRequests": "[it] Outgoing Requests",
    "noIncoming": "[it] No incoming requests",
    "noOutgoing": "[it] No outgoing requests",
    "sentAt": "[it] Sent {{time}}",
    "searchPlaceholder": "[it] Search by name...",
    "noResults": "[it] No players found",
    "noResultsDesc": "[it] Try searching with a different name",
    "requestSent": "[it] Friend request sent!",
    "requestAccepted": "[it] Friend request accepted!",
    "requestRejected": "[it] Friend request rejected",
    "requestCancelled": "[it] Friend request cancelled",
    "friendRemoved": "[it] Friend removed",
    "searchFailed": "[it] Failed to search users",
    "requestFailed": "[it] Failed to send request",
    "acceptFailed": "[it] Failed to accept request",
    "rejectFailed": "[it] Failed to reject request",
    "cancelFailed": "[it] Failed to cancel request",
    "removeFailed": "[it] Failed to remove friend",
    "friendsCount": "[it] {{count}} friends",
    "gamesCount": "[it] {{count}} games",
    "alreadyFriends": "[it] Friends"
  },
  "stats": {
    "statistics": "[it] Statistics",
    "matchHistory": "[it] Match History",
    "headToHead": "[it] Head to Head",
    "gamesPlayed": "[it] Games Played",
    "wins": "[it] Wins",
    "losses": "[it] Losses",
    "draws": "[it] Draws",
    "winRate": "[it] Win Rate",
    "rating": "[it] Rating",
    "peakRating": "[it] Peak Rating",
    "peak": "[it] Peak",
    "winStreak": "[it] Win Streak",
    "currentStreak": "[it] Current Streak",
    "bestStreak": "[it] Best Streak",
    "performance": "[it] Performance",
    "achievements": "[it] Achievements",
    "currentRating": "[it] Current Rating",
    "totalGames": "[it] Total Games",
    "noGames": "[it] No games played yet",
    "moves": "[it] moves",
    "won": "[it] Won",
    "lost": "[it] Lost",
    "draw": "[it] Draw",
    "overall": "[it] Overall Record",
    "yourWins": "[it] Your Wins",
    "theirWins": "[it] Their Wins",
    "totalGamesPlayed": "[it] Total: {{count}} games",
    "recentGames": "[it] Recent Games"
  },
  "support": {
    "title": "Centro assistenza",
    "subtitle": "Come possiamo aiutarti oggi?",
    "tabs": {
      "docs": "Documentazione",
      "faq": "FAQ",
      "contact": "Contatti",
      "tickets": "I miei ticket"
    },
    "categories": {
      "title": "[it] Browse Documentation",
      "loading": "[it] Loading documentation...",
      "loadError": "[it] Failed to load categories",
      "articleCount": "[it] {{count}} articles",
      "gettingStarted": "[it] Getting Started",
      "features": "[it] Features",
      "troubleshooting": "[it] Troubleshooting",
      "account": "[it] Account"
    },
    "docs": {
      "loading": "[it] Loading document...",
      "loadError": "[it] Failed to load document",
      "backToList": "[it] Back to documentation"
    },
    "search": {
      "placeholder": "[it] Search documentation...",
      "noResults": "[it] No results found"
    },
    "faq": {
      "title": "Domande frequenti",
      "loading": "Caricamento FAQ...",
      "loadError": "Impossibile caricare le FAQ",
      "empty": "[it] No FAQ items in this category",
      "categories": {
        "all": "Tutti gli argomenti",
        "general": "Generale",
        "billing": "Fatturazione",
        "technical": "Tecnico",
        "features": "Funzionalità"
      }
    },
    "contact": {
      "voiceTitle": "Supporto vocale",
      "voiceDescription": "Clicca sul pulsante avatar o dì \"Jarvis\" per iniziare una conversazione vocale.",
      "ticketTitle": "Crea ticket di supporto",
      "ticketDescription": "Hai bisogno di assistenza umana? Crea un ticket e il nostro team risponderà entro 24 ore.",
      "createTicket": "Crea ticket",
      "emailTitle": "Supporto email",
      "emailDescription": "Preferisci l'email? Contattaci a support@bayit.tv."
    },
    "ticket": {
      "title": "[it] Create Support Ticket",
      "subject": "[it] Subject",
      "subjectPlaceholder": "[it] Brief description of your issue",
      "message": "[it] Message",
      "messagePlaceholder": "[it] Describe your issue in detail...",
      "categoryLabel": "[it] Category",
      "priorityLabel": "[it] Priority",
      "submit": "[it] Submit Ticket",
      "category": {
        "billing": "[it] Billing",
        "technical": "[it] Technical",
        "feature": "[it] Feature Request",
        "general": "[it] General"
      },
      "priority": {
        "low": "[it] Low",
        "medium": "[it] Medium",
        "high": "[it] High",
        "urgent": "[it] Urgent"
      },
      "status": {
        "open": "[it] Open",
        "in_progress": "[it] In Progress",
        "resolved": "[it] Resolved",
        "closed": "[it] Closed"
      },
      "created": "[it] Created",
      "error": {
        "required": "[it] Please fill in all required fields",
        "submit": "[it] Failed to create ticket. Please try again."
      }
    },
    "tickets": {
      "title": "[it] My Support Tickets",
      "loading": "[it] Loading tickets...",
      "loadError": "[it] Failed to load tickets",
      "empty": "[it] No support tickets yet",
      "emptyFilter": "[it] No tickets with this status",
      "create": "[it] New Ticket",
      "createFirst": "[it] Create Your First Ticket",
      "filter": {
        "all": "[it] All",
        "open": "[it] Open",
        "inProgress": "[it] In Progress",
        "resolved": "[it] Resolved"
      }
    },
    "voice": {
      "title": "[it] Voice Assistant",
      "listening": "[it] I'm listening...",
      "thinking": "[it] Let me think about that...",
      "speaking": "[it] Speaking...",
      "error": "[it] Sorry, I didn't catch that. Try again?",
      "ready": "[it] What would you like to know?",
      "listeningNow": "[it] Listening...",
      "wakeWordHint": "[it] Say \"Jarvis\" to speak"
    },
    "wizard": {
      "role": "[it] Your Guide"
    }
  },
  "jerusalem": {
    "title": "[it] Jerusalem Connection",
    "subtitle": "[it] Stay connected to the heart of Israel",
    "noContent": "[it] No Jerusalem content available",
    "sources": "[it] Sources",
    "kotelLive": "[it] Western Wall Live",
    "categories": {
      "kotel": "[it] Western Wall",
      "idf-ceremony": "[it] IDF Ceremonies",
      "diaspora-connection": "[it] Diaspora Connection",
      "holy-sites": "[it] Holy Sites",
      "jerusalem-events": "[it] Jerusalem Events",
      "general": "[it] Jerusalem"
    }
  },
  "telAviv": {
    "title": "[it] Tel Aviv Connection",
    "subtitle": "[it] The city that never stops",
    "noContent": "[it] No Tel Aviv content available",
    "sources": "[it] Sources",
    "beachLive": "[it] Beach Webcam",
    "categories": {
      "beaches": "[it] Beaches",
      "nightlife": "[it] Nightlife",
      "culture": "[it] Culture & Art",
      "music": "[it] Music Scene",
      "food": "[it] Food & Dining",
      "tech": "[it] Tech & Startups",
      "events": "[it] Events",
      "general": "[it] Tel Aviv"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "[it] Welcome to Voice Control",
      "description": "[it] Control Bayit+ with your voice for a hands-free experience."
    },
    "features": {
      "voiceCommands": "Comandi Vocali",
      "voiceCommandsDesc": "Naviga, cerca e controlla la riproduzione con il linguaggio naturale",
      "tts": "Sintesi Vocale",
      "ttsDesc": "Ascolta le risposte e le descrizioni dei contenuti ad alta voce",
      "wakeWord": "Parola di Attivazione",
      "wakeWordDesc": "Dì 'Bayit' per attivare il controllo vocale in qualsiasi momento"
    },
    "getStarted": "Inizia",
    "permissions": {
      "title": "Accesso al Microfono",
      "description": "Il controllo vocale richiede l'accesso al microfono per sentire i tuoi comandi",
      "privacy": "I tuoi dati vocali vengono elaborati in modo sicuro e non vengono mai memorizzati"
    },
    "permissionsGranted": "Accesso al microfono concesso",
    "permissionRequired": {
      "title": "Permesso Richiesto",
      "message": "Abilita l'accesso al microfono nelle impostazioni del tuo dispositivo per usare il controllo vocale"
    },
    "grantPermissions": "Concedi Permessi",
    "testWakeWord": {
      "title": "Testa la Parola di Attivazione",
      "description": "Dì 'Bayit' per testare l'attivazione vocale",
      "success": "Ottimo! L'attivazione vocale funziona"
    },
    "startTest": "Inizia Test",
    "complete": {
      "title": "Tutto Pronto!",
      "description": "Il controllo vocale è ora abilitato. Prova questi comandi:",
      "tryCommands": "Prova Questi Comandi",
      "examples": {
        "search": "\"Cerca Fauda\"",
        "play": "\"Riproduci le notizie\"",
        "navigate": "\"Vai alla TV in Diretta\"",
        "control": "\"Pausa\" o \"Alza il volume\""
      },
      "startUsing": "Inizia a Usare il Controllo Vocale"
    },
    "skip": "Salta per ora",
    "buttons": {
      "back": "[it] Back"
    },
    "completion": {
      "message": "[it] Voice features are ready to use.",
      "title": "[it] Voice Setup Complete"
    },
    "title": "[it] Voice Setup",
    "training": {
      "message": "[it] Read the phrases aloud to train voice recognition.",
      "title": "[it] Voice Training"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "[it] Movies",
      "series": "[it] Series",
      "kids": "[it] Kids",
      "youngsters": "[it] Youngsters",
      "music": "[it] Music",
      "documentaries": "[it] Documentaries",
      "podcasts": "[it] Podcasts",
      "live": "[it] Live TV"
    },
    "subcategories": {
      "learning-hebrew": "[it] Learning Hebrew",
      "young-science": "[it] Young Science",
      "math-fun": "[it] Fun Math",
      "nature-animals": "[it] Nature & Animals",
      "interactive": "[it] Interactive",
      "hebrew-songs": "[it] Hebrew Songs",
      "nursery-rhymes": "[it] Nursery Rhymes",
      "kids-movies": "[it] Kids Movies",
      "kids-series": "[it] Kids Series",
      "jewish-holidays": "[it] Jewish Holidays",
      "torah-stories": "[it] Torah Stories",
      "bedtime-stories": "[it] Bedtime Stories",
      "tiktok-trends": "[it] TikTok Trends",
      "viral-videos": "[it] Viral Videos",
      "memes": "[it] Memes",
      "israel-news": "[it] Israel News",
      "world-news": "[it] World News",
      "science-news": "[it] Science News",
      "sports-news": "[it] Sports News",
      "music-culture": "[it] Music Culture",
      "film-culture": "[it] Film Culture",
      "art-culture": "[it] Art Culture",
      "food-culture": "[it] Food Culture",
      "study-help": "[it] Study Help",
      "career-prep": "[it] Career Prep",
      "life-skills": "[it] Life Skills",
      "teen-movies": "[it] Teen Movies",
      "teen-series": "[it] Teen Series",
      "gaming": "[it] Gaming",
      "coding": "[it] Coding",
      "gadgets": "[it] Gadgets",
      "bar-bat-mitzvah": "[it] Bar/Bat Mitzvah",
      "teen-torah": "[it] Teen Torah",
      "jewish-history": "[it] Jewish History",
      "learning-hebrew.description": "Imparare a leggere, scrivere e il vocabolario in ebraico per bambini",
      "young-science.description": "Esperimenti e spiegazioni scientifiche adattati per i bambini",
      "math-fun.description": "Imparare i numeri e l'aritmetica in modo divertente e giocoso",
      "nature-animals.description": "Il mondo degli animali e della natura per bambini curiosi",
      "interactive.description": "Contenuti interattivi e partecipativi per bambini",
      "hebrew-songs.description": "Canzoni israeliane classiche e nuove per bambini",
      "nursery-rhymes.description": "Canzoni e melodie per neonati e bambini piccoli",
      "kids-movies.description": "Film completi adatti ai bambini",
      "kids-series.description": "Serie animate e programmi TV per bambini",
      "jewish-holidays.description": "Contenuti sulle festivita ebraiche e tradizioni per bambini",
      "torah-stories.description": "Storie dalla Torah e dalla tradizione ebraica",
      "bedtime-stories.description": "Storie rilassanti per l'ora della nanna",
      "tiktok-trends.description": "Tendenze e sfide popolari su TikTok",
      "viral-videos.description": "Video virali popolari sui social media",
      "memes.description": "Meme divertenti e cultura di internet",
      "israel-news.description": "Notizie di Israele adattate per adolescenti",
      "world-news.description": "Notizie internazionali per giovani",
      "science-news.description": "Scoperte scientifiche e innovazione tecnologica",
      "sports-news.description": "Aggiornamenti sportivi e risultati delle partite",
      "music-culture.description": "Scena musicale, artisti e festival",
      "film-culture.description": "Cinema, serie e recensioni",
      "art-culture.description": "Arte, gallerie e creativita",
      "food-culture.description": "Cucina, ricette e cultura gastronomica",
      "study-help.description": "Aiuto con esami, riassunti e preparazione ai test",
      "career-prep.description": "Preparazione all'universita e alla carriera",
      "life-skills.description": "Abilita di vita, gestione del denaro e indipendenza",
      "teen-movies.description": "Film consigliati per adolescenti",
      "teen-series.description": "Serie popolari per adolescenti",
      "gaming.description": "Videogiochi, e-sport e gaming",
      "coding.description": "Programmazione, coding e sviluppo software",
      "gadgets.description": "Gadget, tecnologia e recensioni",
      "bar-bat-mitzvah.description": "Preparazione e celebrazioni per Bar/Bat Mitzvah",
      "teen-torah.description": "Lezioni di Torah e parasha settimanale per adolescenti",
      "jewish-history.description": "Storia del popolo ebraico"
    }
  },
  "passkey": {
    "manager": {
      "title": "[it] Passkeys",
      "subtitle": "[it] Manage your passkeys for secure content access"
    },
    "unsupported": "[it] Passkeys are not supported on this device",
    "fetchError": "[it] Failed to load passkeys",
    "registerError": "[it] Failed to register passkey",
    "deleteError": "[it] Failed to delete passkey",
    "cancelled": "[it] Passkey operation was cancelled",
    "noPasskeys": "[it] No passkeys registered yet. Add one to unlock private content.",
    "unknownDevice": "[it] Unknown Device",
    "created": "[it] Created",
    "lastUsed": "[it] Last used",
    "never": "[it] Never",
    "addPasskey": "[it] Add Passkey",
    "deleteConfirmTitle": "[it] Delete Passkey?",
    "deleteConfirmText": "[it] This passkey will no longer be able to unlock content. You can always add it again later.",
    "unlock": "[it] Unlock",
    "unlockContent": "[it] Unlock Private Content",
    "unlockDescription": "[it] Use your passkey to access private movies and series",
    "auth": {
      "title": "[it] Unlock Content",
      "description": "[it] Use your fingerprint, face, or device PIN to unlock private movies and series.",
      "unlock": "[it] Unlock with Passkey",
      "authenticating": "[it] Authenticating...",
      "success": "[it] Content Unlocked!",
      "cancelled": "[it] Authentication was cancelled",
      "error": "[it] Authentication failed. Please try again."
    },
    "qr": {
      "useQR": "[it] Use Phone to Unlock",
      "scanWithPhone": "[it] Scan with your phone",
      "instruction": "[it] Open the camera on your phone and scan the QR code to authenticate",
      "error": "[it] Failed to generate QR code",
      "expired": "[it] QR code expired. Please try again."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "[it] Session not found",
      "session_different_partner": "[it] Session belongs to different partner",
      "session_invalid_status": "[it] Session is {status}, cannot add transcript",
      "max_sessions_reached": "[it] Maximum concurrent sessions ({limit}) reached",
      "invalid_api_key": "[it] Invalid API key",
      "missing_api_key": "[it] Missing {header} header",
      "capability_disabled": "[it] Capability '{capability}' is currently disabled",
      "capability_not_enabled": "[it] Capability '{capability}' not enabled for this partner",
      "source_language_not_supported": "[it] Source language '{language}' not supported. Supported: {supported}",
      "target_language_not_supported": "[it] Target language '{language}' not supported. Supported: {supported}",
      "partner_not_found": "[it] Partner not found",
      "partner_registration_failed": "[it] Failed to register partner",
      "no_updates_provided": "[it] No updates provided",
      "webhook_config_failed": "[it] Failed to configure webhook",
      "webhook_url_not_configured": "[it] Webhook URL not configured",
      "webhook_secret_not_configured": "[it] Webhook secret not configured",
      "search_failed": "[it] Search failed",
      "indexing_failed": "[it] Indexing failed",
      "detection_failed": "[it] Detection failed",
      "explanation_failed": "[it] Failed to get explanation",
      "reference_not_found": "[it] Reference '{reference_id}' not found",
      "enrichment_failed": "[it] Enrichment failed",
      "get_references_failed": "[it] Failed to get references",
      "create_session_failed": "[it] Failed to create session",
      "add_transcript_failed": "[it] Failed to add transcript",
      "generate_recap_failed": "[it] Failed to generate recap"
    }
  },
  "portal": {
    "nav": {
      "home": "Home",
      "features": "Caratteristiche",
      "solutions": "Soluzioni",
      "pricing": "Prezzi",
      "demo": "Demo dal Vivo",
      "contact": "Contatto",
      "getStarted": "Inizia"
    },
    "hero": {
      "ctaExplore": "Esplora le Caratteristiche",
      "ctaDemo": "Richiedi Demo"
    },
    "cta": {
      "title": "Pronto per Iniziare?",
      "subtitle": "Parliamo di come possiamo aiutare a trasformare il tuo business",
      "button": "Contattaci"
    },
    "contactPage": {
      "title": "Mettiti in Contatto",
      "subtitle": "Interessato alle nostre soluzioni? Parliamone",
      "formTitle": "Inviaci un Messaggio",
      "infoTitle": "Informazioni di Contatto",
      "form": {
        "name": "Nome Completo",
        "email": "Indirizzo Email",
        "company": "Nome Azienda",
        "phone": "Numero di Telefono",
        "message": "Il Tuo Messaggio",
        "messagePlaceholder": "Raccontaci delle tue esigenze..."
      },
      "submit": "Invia Messaggio",
      "sending": "Invio in corso...",
      "success": "Messaggio inviato con successo! Ti ricontatteremo presto.",
      "error": "Invio del messaggio fallito. Riprova.",
      "scheduleTitle": "Preferisci Programmare una Chiamata?",
      "scheduleSubtitle": "Prenota una demo personalizzata con il nostro team",
      "scheduleCta": "Programma Chiamata Demo"
    },
    "pricingPage": {
      "title": "Conveniente",
      "titleHighlight": "Piani Tariffari",
      "subtitle": "Scegli il piano adatto alle tue esigenze",
      "comparisonTitle": "Confronto delle Caratteristiche",
      "faqTitle": "Domande Frequenti",
      "faq": {
        "q1": "Come viene calcolato il prezzo?",
        "a1": "Il prezzo si basa sulle tue esigenze specifiche e sull'utilizzo. Contattaci per un preventivo personalizzato.",
        "q2": "Posso aggiornare il mio piano più tardi?",
        "a2": "Sì, puoi aggiornare in qualsiasi momento. Ti aiuteremo a migrare i tuoi dati senza problemi.",
        "q3": "Quale supporto è incluso?",
        "a3": "Tutti i piani includono supporto via email. I piani Professional ed Enterprise includono supporto prioritario con account manager dedicati."
      },
      "professional": {
        "name": "Professionale",
        "price": "Contatta per Preventivo",
        "priceNote": "Prezzi personalizzati",
        "description": "Per aziende in crescita con esigenze avanzate",
        "cta": "Ottieni Preventivo"
      },
      "enterprise": {
        "name": "Enterprise",
        "price": "Personalizzato",
        "priceNote": "Basato sul volume",
        "description": "Per grandi organizzazioni e implementazioni aziendali",
        "cta": "Contatta Vendite"
      },
      "ctaTitle": "Pronto per Iniziare?",
      "ctaSubtitle": "Parliamo delle tue esigenze e troviamo il piano perfetto",
      "ctaButton": "Contatta Vendite"
    },
    "featuresPage": {
      "title": "Potenti",
      "titleHighlight": "Caratteristiche",
      "subtitle": "Tutto ciò di cui hai bisogno per avere successo",
      "techSpecsTitle": "Specifiche Tecniche",
      "workflowTitle": "Come Funziona",
      "workflow": {
        "s1": {
          "title": "Importa",
          "description": "Carica e organizza i tuoi contenuti"
        },
        "s2": {
          "title": "Configura",
          "description": "Imposta le tue preferenze e impostazioni"
        },
        "s3": {
          "title": "Distribuisci",
          "description": "Vai online con la tua soluzione"
        },
        "s4": {
          "title": "Monitora",
          "description": "Traccia le prestazioni e ottimizza"
        }
      },
      "ctaTitle": "Pronto per Esplorare le Caratteristiche?",
      "ctaSubtitle": "Vedi tutte le caratteristiche in azione con una demo personalizzata",
      "ctaButton": "Programma Demo"
    },
    "demoPage": {
      "title": "Vedi la Nostra",
      "titleHighlight": "Piattaforma",
      "subtitle": "Sperimenta la potenza della nostra soluzione",
      "scheduleCta": "Programma Demo dal Vivo",
      "stepsTitle": "Come Funziona",
      "steps": {
        "analyze": {
          "title": "Analizza",
          "description": "Traccia e migliora le prestazioni"
        }
      },
      "featuresTitle": "Punti Salienti della Piattaforma",
      "platformsTitle": "Disponibile Su",
      "ctaTitle": "Pronto per la Tua Demo Personalizzata?",
      "ctaSubtitle": "Programma una dimostrazione personalizzata su misura per le tue esigenze",
      "ctaButton": "Programma Demo"
    },
    "workflow": {
      "sectionTitle": "Flusso di Lavoro Intelligente",
      "sectionSubtitle": "Processo semplificato in 4 passaggi",
      "step1": {
        "title": "Configura",
        "description": "Configura il tuo account e le preferenze"
      },
      "step2": {
        "title": "Personalizza",
        "description": "Personalizza le impostazioni per le tue esigenze"
      },
      "step3": {
        "title": "Lancia",
        "description": "Avvia la tua soluzione"
      },
      "step4": {
        "title": "Monitora",
        "description": "Traccia le prestazioni e ottimizza"
      }
    }
  },
  "trivia": {
    "didYouKnow": "Lo Sapevi?",
    "dismissHint": "Chiudi curiosità",
    "settings": {
      "displayLanguages": "Lingue di Visualizzazione",
      "languageHint": "Seleziona 1-3 lingue da visualizzare per ogni fatto",
      "language": "lingua",
      "selectLanguage": "Seleziona questa lingua",
      "deselectLanguage": "Deseleziona questa lingua",
      "enableDescription": "[it] Show trivia questions while watching content.",
      "enableTrivia": "[it] Enable Trivia",
      "title": "[it] Trivia Settings"
    },
    "aiTrivia": "Curiosità IA",
    "tellMeMore": "Dimmi di più",
    "more": "Altro",
    "follow_up": "Seguito"
  },
  "auth": {
    "loginRequired": "[it] Login Required",
    "loginToWatch": "[it] Please sign in to watch {{title}}",
    "login": "[it] Login",
    "signUp": "[it] Sign Up",
    "biometricEnrollEnable": "[it] Enable",
    "biometricEnrollMessage": "[it] Use Face ID or fingerprint for faster sign-in next time.",
    "biometricEnrollSkip": "[it] Skip",
    "biometricEnrollTitle": "[it] Enable Biometric Sign-In",
    "biometricSignIn": "[it] Sign in with Biometrics",
    "signOut": "[it] Sign Out",
    "register": {
      "createAccount": "Crea account",
      "email": "E-mail",
      "password": "Password",
      "confirmPassword": "Conferma password",
      "register": "Registrati",
      "alreadyHaveAccount": "Hai gia un account? Accedi",
      "passwordStrength": {
        "weak": "Debole",
        "medium": "Media",
        "strong": "Forte"
      }
    }
  },
  "recording": {
    "stop": "Ferma Registrazione",
    "start": "Avvia Registrazione"
  },
  "discover": {
    "title": "[it] Discover",
    "subtitle": "Esplora 19 funzionalità basate sull'IA",
    "description": "Bayit+ utilizza l'IA per migliorare la tua esperienza di visione, ascolto e apprendimento. Scopri cosa è disponibile sulla tua piattaforma.",
    "featureCount": "{{count}} funzionalità",
    "tryIt": "Prova",
    "startWalkthrough": "Inizia il tour",
    "availableOn": "Disponibile su",
    "prerequisites": "Prerequisiti",
    "setup": "Configura",
    "error": {
      "fetchFailed": "Impossibile caricare le funzionalità di Discover. Riprova.",
      "unknownFeature": "Funzionalità non trovata.",
      "featureDisabled": "Questa funzionalità è attualmente disabilitata."
    },
    "availability": {
      "ready": "Pronto",
      "setupNeeded": "Configurazione necessaria",
      "premiumRequired": "Premium richiesto",
      "notAvailable": "Non disponibile",
      "platformOnly": "Altra piattaforma"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "Guardare film",
      "watching_live_tv": "Guardare la TV in diretta",
      "learn_hebrew": "Imparare l'ebraico",
      "search_discovery": "Ricerca e scoperta",
      "chat_assistants": "Assistenti di chat"
    },
    "feature": {
      "pause_ask": {
        "name": "Pausa e Chiedi",
        "tagline": "Metti in pausa qualsiasi scena e chiedi al tuo compagno IA",
        "description": "Durante la visione, metti in pausa il video e fai domande sulla scena corrente. Il tuo personaggio IA spiegherà i riferimenti culturali, tradurrà i dialoghi o discuterà della trama."
      },
      "interactive_subtitles": {
        "name": "Sottotitoli interattivi",
        "tagline": "Tocca qualsiasi parola dei sottotitoli per traduzione e contesto istantanei",
        "description": "Clicca su qualsiasi parola nei sottotitoli per vederne la traduzione, sentirne la pronuncia e ottenere esempi d'uso. Arricchisci il vocabolario guardando i tuoi programmi preferiti."
      },
      "vocabulary": {
        "name": "Costruttore di vocabolario",
        "tagline": "Impara nuove parole dai programmi che guardi",
        "description": "Raccogli automaticamente nuove parole ebraiche dai sottotitoli. Ripassa con le flashcard, tieni traccia dei progressi e arricchisci il tuo vocabolario attraverso i contenuti che ami."
      },
      "vod_moments": {
        "name": "Momenti VOD",
        "tagline": "I momenti salienti dei tuoi contenuti preferiti selezionati dall'IA",
        "description": "Ottieni clip dei momenti salienti e punti chiave generati dall'IA da film e programmi. Condividi scene memorabili e rivivi i momenti migliori."
      },
      "cultural_context": {
        "name": "Contesto culturale",
        "tagline": "Comprendi il background culturale dietro ogni scena",
        "description": "Ricevi annotazioni culturali in tempo reale che spiegano usanze israeliane, festività, umorismo e norme sociali presenti nei contenuti che guardi."
      },
      "bilingual_bridge": {
        "name": "Ponte bilingue",
        "tagline": "Apprendimento ebraico-italiano fianco a fianco durante la visione",
        "description": "Visualizza sottotitoli in due lingue con vocabolario evidenziato. Passa dall'ebraico alla tua lingua madre per sviluppare la comprensione in modo naturale."
      },
      "ai_companion": {
        "name": "Compagno IA",
        "tagline": "La tua guida personale IA per i contenuti israeliani",
        "description": "Un personaggio IA che guarda insieme a te, offrendo commenti, rispondendo a domande e aiutandoti a capire le sfumature dei media israeliani."
      },
      "live_dubbing": {
        "name": "Doppiaggio in diretta",
        "tagline": "Doppiaggio IA in tempo reale dei canali TV israeliani in diretta",
        "description": "Guarda la TV israeliana in diretta con doppiaggio in tempo reale basato sull'IA nella tua lingua preferita. Goditi notizie, talk show e intrattenimento senza barriere linguistiche."
      },
      "live_subtitles": {
        "name": "Sottotitoli in diretta",
        "tagline": "Sottotitoli IA in tempo reale per le trasmissioni in diretta",
        "description": "Ricevi sottotitoli generati dall'IA in tempo reale mentre guardi la TV israeliana in diretta. Scegli la tua lingua preferita per la traduzione istantanea dei contenuti in diretta."
      },
      "live_trivia": {
        "name": "Trivia in diretta",
        "tagline": "Gioca a quiz basati su ciò che va in onda in diretta",
        "description": "L'IA rileva gli argomenti dalle trasmissioni in diretta e genera domande di trivia in tempo reale. Gareggia con gli amici e impara la cultura israeliana guardando la TV."
      },
      "catch_up": {
        "name": "Recupero",
        "tagline": "Riepiloghi IA di ciò che ti sei perso in TV in diretta",
        "description": "Hai perso parte di una trasmissione in diretta? Ricevi riepiloghi generati dall'IA che ti aggiornano su quanto accaduto, con i momenti chiave evidenziati per una revisione rapida."
      },
      "scene_search": {
        "name": "Ricerca scena",
        "tagline": "Cerca scene specifiche in tutti i contenuti",
        "description": "Descrivi una scena che ricordi e l'IA la troverà in tutti i contenuti disponibili. Cerca per dialogo, elementi visivi o descrizioni della trama."
      },
      "phonetic_mirror": {
        "name": "Specchio fonetico",
        "tagline": "Esercita la pronuncia dell'ebraico con il feedback dell'IA",
        "description": "Registrati mentre parli ebraico e ricevi un feedback istantaneo dell'IA sulla tua pronuncia. Confronta il tuo parlato con i madrelingua e monitora i progressi nel tempo."
      },
      "talk_back": {
        "name": "Rispondi",
        "tagline": "Fai conversazioni vocali in ebraico con il tuo personaggio IA",
        "description": "Esercita l'ebraico conversazionale parlando con il tuo personaggio IA. Ricevi feedback in tempo reale su grammatica, vocabolario e pronuncia in dialogo naturale."
      },
      "interactive_mission": {
        "name": "Missioni interattive",
        "tagline": "Sfide di apprendimento dell'ebraico con la guida dell'IA",
        "description": "Completa missioni guidate dall'IA che combinano la visione di contenuti con esercizi di apprendimento dell'ebraico. Guadagna premi e monitora il tuo percorso linguistico."
      },
      "glossary": {
        "name": "Glossario personale",
        "tagline": "Il tuo dizionario ebraico personalizzato costruito dai contenuti",
        "description": "Tutte le parole ebraiche che hai incontrato e salvato, organizzate per categoria, frequenza e livello di padronanza. Ripassa e pratica in qualsiasi momento."
      },
      "llm_search": {
        "name": "Ricerca IA",
        "tagline": "Trova contenuti con query in linguaggio naturale",
        "description": "Cerca nell'intera libreria Bayit+ usando il linguaggio naturale. Chiedi 'commedie israeliane divertenti sulla famiglia' o 'documentari su Tel Aviv' e ottieni risultati selezionati dall'IA."
      },
      "proactive_voice": {
        "name": "Voce proattiva",
        "tagline": "Assistente IA vocale che anticipa le tue esigenze",
        "description": "Un assistente IA che ascolta e propone proattivamente suggerimenti di contenuti pertinenti, traduzioni e opportunità di apprendimento in base a ciò che stai guardando."
      },
      "chatbot": {
        "name": "Chat Bayit",
        "tagline": "Chatta con l'IA su tutto ciò che riguarda i contenuti israeliani",
        "description": "Fai domande sulla cultura israeliana, ottieni raccomandazioni di contenuti, esercita l'ebraico o discuti di ciò che hai guardato. Il tuo compagno IA è sempre disponibile."
      }
    },
    "prereq": {
      "avatar": "Crea il tuo personaggio IA",
      "subscription": "Abbonamento Premium richiesto",
      "microphone": "Accesso al microfono necessario",
      "contentType": "Seleziona le tue preferenze di contenuto",
      "preference": "Imposta le tue preferenze linguistiche",
      "voiceClone": "Configura il tuo clone vocale"
    },
    "walkthrough": {
      "tryItNow": "[it] Try it now",
      "watchDemo": "[it] Watch demo",
      "skip": "[it] Skip",
      "next": "[it] Next",
      "done": "[it] Done",
      "complete": "[it] Walkthrough complete",
      "stepCounter": "[it] {{current}} of {{total}}",
      "pause_ask": {
        "step1": "[it] Navigate to a movie with interactive moments",
        "step2": "[it] Pause the movie during a scene",
        "step3": "[it] Tap the Ask a Character button",
        "step4": "[it] Watch the character respond to you"
      },
      "interactive_subtitles": {
        "step1": "[it] Start playing a movie with subtitles",
        "step2": "[it] Tap the Interactive button in the control bar",
        "step3": "[it] Select your subtitle language",
        "step4": "[it] Tap any word in the subtitles to learn more"
      },
      "vocabulary": {
        "step1": "[it] Open a movie with interactive subtitles enabled",
        "step2": "[it] Tap a word you want to learn",
        "step3": "[it] Tap Save to Vocabulary",
        "step4": "[it] Review your saved words in the Vocabulary section"
      },
      "vod_moments": {
        "step1": "[it] Start watching a movie with interactive moments",
        "step2": "[it] Wait for an interactive prompt to appear",
        "step3": "[it] See the AI-generated interaction"
      },
      "cultural_context": {
        "step1": "[it] Play a movie with Hebrew dialogue",
        "step2": "[it] Tap on a subtitle with cultural significance",
        "step3": "[it] Read the AI-generated cultural explanation"
      },
      "bilingual_bridge": {
        "step1": "[it] Open a movie with bilingual support",
        "step2": "[it] Select the bilingual subtitle mode",
        "step3": "[it] Tap a highlighted phrase to see the translation",
        "step4": "[it] Watch both languages side by side"
      },
      "ai_companion": {
        "step1": "[it] Start watching any movie",
        "step2": "[it] Tap the AI Companion button",
        "step3": "[it] Type a question about the movie",
        "step4": "[it] Read the contextual AI response"
      },
      "live_dubbing": {
        "step1": "[it] Navigate to a live TV channel",
        "step2": "[it] Tap the dubbing button in the control bar",
        "step3": "[it] Select your preferred language",
        "step4": "[it] Listen to the real-time AI dubbing"
      },
      "live_subtitles": {
        "step1": "[it] Navigate to a live TV channel",
        "step2": "[it] Tap the subtitles button",
        "step3": "[it] Select your subtitle language",
        "step4": "[it] Watch the real-time subtitles appear"
      },
      "live_trivia": {
        "step1": "[it] Navigate to a live TV channel",
        "step2": "[it] Tap the trivia button",
        "step3": "[it] Answer the AI-generated questions"
      },
      "catch_up": {
        "step1": "[it] Navigate to a live broadcast",
        "step2": "[it] Select the catch-up option",
        "step3": "[it] Tap to generate an AI summary",
        "step4": "[it] Read the summary of what you missed"
      },
      "scene_search": {
        "step1": "[it] Navigate to a recorded broadcast",
        "step2": "[it] Type what you are looking for",
        "step3": "[it] Tap on the matching scene",
        "step4": "[it] Watch the scene from that point"
      },
      "phonetic_mirror": {
        "step1": "[it] Open the Phonetic Mirror in Zeh Ani",
        "step2": "[it] Read the Hebrew phrase shown",
        "step3": "[it] Speak the phrase into your microphone",
        "step4": "[it] Review the AI pronunciation feedback"
      },
      "talk_back": {
        "step1": "[it] Open Talk Back in Zeh Ani",
        "step2": "[it] Listen to your avatar speak Hebrew",
        "step3": "[it] Respond in Hebrew using your microphone",
        "step4": "[it] Review the AI feedback on your response"
      },
      "interactive_mission": {
        "step1": "[it] Open Interactive Missions",
        "step2": "[it] Select a mission level",
        "step3": "[it] Follow the AI-guided exercises",
        "step4": "[it] Complete the mission and earn rewards"
      },
      "glossary": {
        "step1": "[it] Open the Hebrew Glossary",
        "step2": "[it] Search for a Hebrew word",
        "step3": "[it] Listen to the pronunciation"
      },
      "llm_search": {
        "step1": "[it] Open the Search tab",
        "step2": "[it] Type a natural language query",
        "step3": "[it] Browse the AI-curated results"
      },
      "proactive_voice": {
        "step1": "[it] Open the Voice Suggestions feature",
        "step2": "[it] Tap and hold to speak",
        "step3": "[it] Hear the personalized recommendations"
      },
      "chatbot": {
        "step1": "[it] Open the AI Assistant",
        "step2": "[it] Type your question or request",
        "step3": "[it] Read the AI response"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "[it] Bring Your Own Content",
      "subtitle": "[it] Connect your IPTV, Plex, or YouTube sources and enjoy Bayit+ AI features on your own content",
      "connectButton": "[it] Connect Sources",
      "aiFeatures": {
        "dubbing": "[it] AI Dubbing available",
        "subtitles": "[it] Live Subtitles available"
      }
    },
    "pageSubtitle": "Porta i tuoi contenuti - aggiungi sorgenti IPTV e streaming",
    "addSource": "Aggiungi sorgente",
    "sync": "Sincronizza",
    "remove": "Rimuovi",
    "channelCount": "{{count}} canali",
    "empty": {
      "title": "Nessuna sorgente aggiunta",
      "subtitle": "Aggiungi le tue sorgenti IPTV, Xtream o streaming per guardare i tuoi contenuti insieme a Bayit+"
    },
    "source": {
      "iptv": "Sorgente IPTV",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "Aggiungi sorgente IPTV",
      "subtitle": "Inserisci un URL a un file di playlist M3U o M3U8",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "Valida",
      "add": "Aggiungi sorgente"
    },
    "addXtream": {
      "title": "Collega Xtream Codes",
      "subtitle": "Inserisci le credenziali del tuo server Xtream Codes",
      "serverUrl": "URL del server",
      "username": "Nome utente",
      "password": "Password",
      "connect": "Connetti"
    },
    "preview": {
      "title": "Anteprima",
      "channelCount": "{{count}} canali trovati"
    },
    "providers": {
      "title": "Provider popolari"
    },
    "wizard": {
      "step1": "Aggiungi sorgente",
      "step2": "Elaborazione",
      "step3": "Revisione",
      "selectSource": "Seleziona tipo di sorgente"
    },
    "normalization": {
      "title": "Elaborazione dei tuoi contenuti",
      "total": "{{count}} canali totali",
      "matched": "{{count}} corrispondenze",
      "stage": {
        "parsing": "Analisi della playlist...",
        "matching": "Ricerca corrispondenze canali...",
        "enriching": "Arricchimento dei metadati...",
        "finalizing": "Finalizzazione..."
      }
    },
    "review": {
      "title": "Revisione contenuti importati",
      "subtitle": "{{matched}} corrispondenze, {{unmatched}} canali senza corrispondenza",
      "matchedChannels": "Canali corrispondenti",
      "unmatchedChannels": "Canali senza corrispondenza",
      "apply": "Applica e importa"
    },
    "error": {
      "urlRequired": "Inserisci un URL",
      "noChannels": "Nessun canale trovato in questa playlist",
      "invalidUrl": "Impossibile caricare la playlist da questo URL",
      "allFieldsRequired": "Tutti i campi sono obbligatori",
      "enrichFailed": "Impossibile analizzare la sorgente",
      "syncFailed": "Impossibile sincronizzare la sorgente",
      "normalizationFailed": "L'elaborazione del contenuto non è riuscita",
      "normalizationPollFailed": "Connessione persa durante l'elaborazione"
    },
    "plex": {
      "connectPlex": "Connetti Plex",
      "enterCodeAt": "Inserisci questo codice su",
      "waitingForAuth": "In attesa di autorizzazione...",
      "selectServer": "Seleziona un server Plex",
      "connecting": "Connessione a {{serverName}}...",
      "connected": "Connesso",
      "label": "Plex"
    },
    "settings": {
      "title": "Le tue fonti di contenuto",
      "refresh": "Aggiorna",
      "noSources": "Nessuna fonte di contenuto connessa",
      "noSourcesSubtitle": "Connetti il tuo Plex, YouTube, IPTV o provider Xtream",
      "removeSource": "Rimuovi fonte",
      "plexSubtitle": "Trasmetti dal tuo server multimediale Plex",
      "youtubeSubtitle": "Accedi alla tua libreria YouTube",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "Aggiungi una playlist M3U o codici Xtream",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Benvenuto su Bayit+",
      "subtitle": "Il tuo gateway potenziato dall'IA verso i contenuti israeliani, la cultura e l'apprendimento della lingua",
      "getStarted": "Inizia"
    },
    "highlight": {
      "dubbing": "Doppiaggio IA in diretta",
      "subtitles": "Sottotitoli interattivi",
      "ai": "Compagni IA",
      "learning": "Apprendimento dell'ebraico"
    },
    "voice": {
      "title": "Configurazione voce",
      "subtitle": "Attiva il microfono per i comandi vocali, la pratica della pronuncia in ebraico e la navigazione a mani libere",
      "enable": "Attiva microfono",
      "granted": "Microfono attivato con successo"
    },
    "tour": {
      "done": "Fine"
    },
    "demo": {
      "dubbing": {
        "title": "Doppiaggio IA in diretta",
        "description": "Guarda la TV israeliana con doppiaggio IA in tempo reale nella tua lingua preferita",
        "hebrew": "Ebraico",
        "english": "Inglese"
      },
      "subtitles": {
        "title": "Sottotitoli interattivi",
        "description": "Tocca qualsiasi parola nei sottotitoli per traduzione e pronuncia istantanee",
        "sample": "La famiglia si è riunita per la cena di Shabbat",
        "word": "Shabbat",
        "translation": "Sabato - giorno di riposo settimanale"
      },
      "interaction": {
        "title": "Interazione con personaggio IA",
        "description": "Metti in pausa qualsiasi scena e chiedi al tuo compagno IA il contesto culturale",
        "userMsg": "Quale festività stanno celebrando?",
        "aiMsg": "Stanno celebrando Sukkot, la Festa dei Tabernacoli. La capanna temporanea che vedi si chiama sukkah."
      },
      "trivia": {
        "title": "Trivia in diretta",
        "description": "L'IA genera domande di trivia da ciò che va in onda. Gareggia e impara!",
        "question": "Qual è la lingua ufficiale di Israele?",
        "optionA": "Arabo",
        "optionB": "Ebraico",
        "optionC": "Inglese"
      },
      "catchup": {
        "title": "Recupero intelligente",
        "description": "Hai perso parte di una diretta? L'IA riassume quello che hai perso",
        "missed": "Perso",
        "summary": "Riepilogo IA",
        "live": "In diretta"
      },
      "byoc": {
        "title": "Porta il tuo contenuto",
        "description": "Importa le tue sorgenti IPTV e guardali insieme ai contenuti Bayit+",
        "step1": "Aggiungi sorgente",
        "step2": "Arricchimento IA",
        "step3": "Guarda"
      },
      "zehAni": {
        "title": "Crea il tuo personaggio IA",
        "description": "Genera un avatar IA personalizzato che impara con te",
        "generated": "Avatar IA"
      }
    }
  },
  "dm": {
    "title": "Messaggi",
    "conversations": "Conversazioni",
    "conversation": "Conversazione",
    "empty": {
      "title": "Nessun messaggio ancora",
      "subtitle": "Inizia una conversazione con un amico"
    },
    "input": {
      "placeholder": "Scrivi un messaggio...",
      "send": "Invia"
    },
    "translate": "Traduci",
    "react": "Reagisci",
    "read": "Letto",
    "sent": "Inviato",
    "loadMore": "Carica messaggi precedenti",
    "startConversation": "Invia un messaggio per avviare la conversazione",
    "reaction": {
      "like": "Mi piace",
      "love": "Adoro",
      "laugh": "Haha",
      "surprise": "Wow",
      "sad": "Triste"
    },
    "error": {
      "fetchFailed": "Impossibile caricare i messaggi",
      "sendFailed": "Impossibile inviare il messaggio"
    }
  },
  "household": {
    "empty": {
      "title": "Nessun nucleo familiare ancora",
      "subtitle": "Crea un nucleo familiare per gestire la tua famiglia"
    },
    "create": {
      "namePlaceholder": "Nome del nucleo familiare",
      "button": "Crea nucleo familiare"
    },
    "members": "Membri",
    "role": {
      "owner": "Proprietario",
      "guardian": "Tutore",
      "child": "Figlio"
    },
    "invite": {
      "title": "Invita membri",
      "emailPlaceholder": "Indirizzo email",
      "send": "Invia invito",
      "pending": "Inviti in sospeso"
    },
    "removeMember": "Rimuovi",
    "error": {
      "fetchFailed": "Impossibile caricare il nucleo familiare",
      "createFailed": "Impossibile creare il nucleo familiare",
      "updateFailed": "Impossibile aggiornare il nucleo familiare",
      "deleteFailed": "Impossibile eliminare il nucleo familiare",
      "inviteFailed": "Impossibile inviare l'invito",
      "removeFailed": "Impossibile rimuovere il membro"
    }
  },
  "aiChat": {
    "retryButton": "[it] Retry",
    "sendButton": "[it] Send",
    "title": "[it] AI Chat",
    "voiceButton": "[it] Voice"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "[it] Back"
    },
    "completion": {
      "message": "[it] You're all set! Start exploring AI features.",
      "title": "[it] Setup Complete"
    },
    "permissions": {
      "description": "[it] Grant permissions to enable AI features like voice and camera.",
      "title": "[it] Permissions"
    },
    "personalization": {
      "description": "[it] Tell us your preferences to personalize your AI experience.",
      "title": "[it] Personalization"
    },
    "title": "[it] AI Setup",
    "welcome": {
      "description": "[it] Bayit+ uses AI to enhance your viewing experience with dubbing, subtitles, and more.",
      "title": "[it] Welcome to Bayit+ AI"
    }
  },
  "auth_device_authorized": "[it] Device authorized",
  "auth_device_code_expired": "[it] Code expired",
  "auth_device_get_new_code": "[it] Get new code",
  "auth_device_manual_login": "[it] Sign in manually",
  "auth_device_visit_uri": "[it] Visit the URL shown on your TV",
  "avatar": {
    "tapToSpeak": "[it] Tap to speak",
    "title": "[it] Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "[it] Dubbed Audio",
      "originalAudio": "[it] Original Audio",
      "title": "[it] Audio Mixer"
    },
    "settings_title": "[it] Dubbing Settings",
    "target_language": "[it] Target Language",
    "voiceSelector": {
      "selected": "[it] Selected",
      "subtitle": "[it] Choose a voice for dubbing",
      "title": "[it] Voice Selection"
    }
  },
  "go_back": "[it] Go Back",
  "miniPlayer": {
    "closePlayer": "[it] Close Player",
    "skipBackward": "[it] Skip Backward",
    "skipForward": "[it] Skip Forward"
  },
  "retry": "[it] Retry",
  "search_hint": "[it] Search channels, movies, shows...",
  "search_no_results": "[it] No results found",
  "search_prompt": "[it] What are you looking for?",
  "subscription_required": "[it] Subscription Required",
  "subscription_upsell_tv": "[it] Upgrade to watch on TV",
  "talkback": {
    "title": "[it] Talkback"
  },
  "voiceAssistant": {
    "fabLabel": "[it] Voice Assistant",
    "modal": {
      "cancel": "[it] Cancel",
      "setupMessage": "[it] Set up voice recognition to use the voice assistant.",
      "setupRequired": "[it] Setup Required",
      "startSetup": "[it] Start Setup",
      "title": "[it] Voice Assistant"
    }
  },
  "voiceCommand": {
    "executing": "[it] Executing...",
    "listening": "[it] Listening...",
    "noMatch": "[it] No match found",
    "recognized": "[it] Recognized"
  },
  "voiceDecision": {
    "cancel": "[it] Cancel",
    "confirm": "[it] Confirm",
    "matched": "[it] Matched"
  },
  "voiceSearch": {
    "listening": "[it] Listening...",
    "noResults": "[it] No results found",
    "tapToSpeak": "[it] Tap to speak",
    "title": "[it] Voice Search"
  },
  "voiceSettings": {
    "language": "[it] Language",
    "speechRate": "[it] Speech Rate",
    "title": "[it] Voice Settings",
    "ttsProvider": "[it] TTS Provider",
    "voiceMode": "[it] Voice Mode",
    "voiceSelection": "[it] Voice Selection",
    "wakeWord": "[it] Wake Word"
  },
  "voiceWizard": {
    "buttons": {
      "back": "[it] Back"
    },
    "calibration": {
      "description": "[it] Speak normally to calibrate the microphone.",
      "listening": "[it] Listening...",
      "micButton": "[it] Start Recording",
      "resultTitle": "[it] Calibration Result",
      "stopButton": "[it] Stop Recording",
      "tapToStart": "[it] Tap to start calibration",
      "title": "[it] Microphone Calibration"
    },
    "complete": {
      "message": "[it] Voice wizard setup is complete. You can now use voice features.",
      "title": "[it] Setup Complete"
    },
    "language": {
      "description": "[it] Select your preferred language for voice commands.",
      "title": "[it] Voice Language"
    },
    "permission": {
      "description": "[it] Microphone access is needed for voice features.",
      "granted": "[it] Permission Granted",
      "requestButton": "[it] Grant Permission",
      "title": "[it] Microphone Permission"
    },
    "title": "[it] Voice Wizard"
  },
  "watch_now": "[it] Watch Now",
  "culture": {
    "title": "Cultura israeliana",
    "description": "Gerusalemme, Tel Aviv e patrimonio israeliano",
    "shabbat": {
      "title": "Modalità Shabbat",
      "enableShabbatMode": "Abilita modalità Shabbat",
      "shabbatTimes": "Orari dello Shabbat",
      "timesDescription": "Gli orari dell'accensione delle candele e dell'Havdalah saranno visualizzati qui",
      "aboutTitle": "Informazioni sulla modalità Shabbat",
      "aboutDescription": "Quando attivata, la modalità Shabbat metterà in pausa le notifiche, ridurrà la luminosità dello schermo e abiliterà un'interfaccia semplificata durante le ore dello Shabbat."
    },
    "judaism": {
      "holidaysAndTorah": "Festività e Torah",
      "parashaOfTheWeek": "Parasha della settimana",
      "parashaDescription": "Lettura settimanale della Torah e commento"
    },
    "morning": {
      "title": "Rituale mattutino",
      "description": "Inizia la giornata con intenzione e gratitudine",
      "dailyInspiration": "Ispirazione quotidiana",
      "dailyInspirationDescription": "Contenuti selezionati per la tua routine mattutina",
      "modehAni": "Modeh Ani",
      "modehAniDescription": "Preghiera di gratitudine mattutina",
      "netilatYadayim": "Netilat Yadayim",
      "netilatYadayimDescription": "Lavaggio rituale delle mani",
      "shacharit": "Shacharit",
      "shacharitDescription": "Servizio di preghiera mattutina"
    },
    "glossary": {
      "termDetail": "Dettaglio del termine",
      "definition": "Definizione",
      "pronunciation": "Pronuncia",
      "examples": "Esempi"
    },
    "jerusalem": {
      "title": "Gerusalemme"
    },
    "telaviv": {
      "title": "Tel Aviv"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "Zeh Ani",
      "biometricConsent": "Consenso biometrico",
      "activeConsents": "{{count}} consensi attivi",
      "magicMirror": "Specchio magico",
      "magicMirrorDescription": "Saluti giornalieri e riconoscimento facciale",
      "v2vPractice": "Pratica V2V",
      "v2vPracticeDescription": "Pronuncia voce-a-voce",
      "avatar3d": "Avatar 3D",
      "avatar3dDescription": "La tua mesh avatar personalizzata",
      "movieInteractions": "Interazioni con i film",
      "movieInteractionsDescription": "Sfoglia e parla con i personaggi dei film",
      "contacts": "Contatti",
      "contactsDescription": "Condivisione contatti WhatsApp",
      "feedback": "Feedback",
      "feedbackDescription": "Condividi la tua esperienza",
      "consent": "Consenso",
      "consentDescription": "Gestione del consenso biometrico",
      "chess": "Scacchi",
      "chessDescription": "Gioca a scacchi con amici e familiari"
    },
    "mirror": {
      "title": "Specchio magico",
      "avatarContentDescription": "Avatar",
      "wordOfTheDay": "Parola del giorno",
      "playLipsync": "Avvia sincronizzazione labiale",
      "noAvatarYet": "Nessun avatar ancora",
      "noAvatarDescription": "Crea un avatar 3D per vederti nella storia",
      "createAvatar": "Crea avatar"
    },
    "mode": {
      "title": "Modalità avatar",
      "enableAvatarMode": "Abilita modalità avatar",
      "enableDescription": "Mostra il tuo avatar che reagisce ai contenuti",
      "avatarPreview": "Anteprima avatar",
      "avatarPreviewContentDescription": "Anteprima avatar",
      "noAvatarConfigured": "Nessun avatar configurato",
      "reactionStyle": "Stile di reazione"
    },
    "wardrobe": {
      "title": "Guardaroba",
      "equippedContentDescription": "Equipaggiato"
    },
    "settings": {
      "title": "Impostazioni avatar",
      "privacy": "Privacy",
      "privateAvatarMode": "Modalità avatar privato",
      "privateAvatarDescription": "Nascondi il tuo avatar dagli altri utenti",
      "appearance": "Aspetto",
      "enableAnimations": "Abilita animazioni",
      "animationsDescription": "Anima i movimenti e le espressioni dell'avatar",
      "availableOutfits": "Abiti disponibili"
    },
    "selfie": {
      "title": "Video selfie",
      "camera": "Fotocamera",
      "cameraPreview": "Anteprima fotocamera",
      "startRecording": "Avvia registrazione",
      "stopRecording": "Ferma registrazione",
      "rec": "REC",
      "enterPin": "Inserisci il tuo PIN per creare un avatar",
      "pinLabel": "PIN",
      "retake": "Riprendi",
      "creatingAvatar": "Creazione del tuo avatar...",
      "avatarCreated": "Avatar creato con successo",
      "avatarPreviewContentDescription": "Anteprima avatar",
      "createAnother": "Crea un altro"
    },
    "mesh": {
      "title": "Avatar 3D",
      "meshViewer": "Visualizzatore mesh 3D",
      "meshViewerDescription": "Il visualizzatore mesh 3D richiede l'integrazione di WebView o GLSurfaceView",
      "skinTone": "Tonalità della pelle",
      "hairStyle": "Acconciatura",
      "accessories": "Accessori",
      "saveChanges": "Salva modifiche"
    },
    "v2v": {
      "title": "Pratica vocale",
      "nextPhrase": "Frase successiva",
      "stop": "Ferma",
      "record": "Registra",
      "mic": "MIC",
      "viewProgress": "Visualizza progressi",
      "analyzingPronunciation": "Analisi della pronuncia...",
      "pronunciationFeedback": "Feedback sulla pronuncia",
      "similarity": "Somiglianza: {{score}}%",
      "yourProgress": "I tuoi progressi",
      "transforms": "Trasformazioni: {{count}}",
      "improvement": "Miglioramento: {{score}}%",
      "continuePracticing": "Continua a praticare"
    },
    "characters": {
      "title": "Personaggi",
      "noCharactersFound": "Nessun personaggio trovato per questo film",
      "characterCount": "{{count}} personaggi"
    },
    "interactions": {
      "title": "Interazioni con i film",
      "noInteractableMovies": "Nessun film interattivo disponibile"
    },
    "feedbackInbox": {
      "title": "Posta dei feedback",
      "refreshContentDescription": "Aggiorna",
      "noFeedbackYet": "Nessun feedback ancora",
      "feedbackAppearHere": "I feedback dai tuoi contatti appariranno qui",
      "playVoiceMessage": "Riproduci messaggio vocale"
    },
    "addContact": {
      "title": "Aggiungi contatto",
      "nameLabel": "Nome",
      "phoneLabel": "Telefono",
      "relationship": "Relazione",
      "language": "Lingua"
    },
    "avatar3d": {
      "title": "Avatar 3D",
      "glbMeshViewer": "Visualizzatore mesh GLB",
      "controls": "Controlli",
      "animate": "Anima",
      "vertices": "Vertici",
      "bones": "Ossa",
      "blendShapes": "Forme di fusione",
      "hasGlb": "Ha GLB",
      "status": "Stato: {{value}}"
    }
  }
}
